//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
  protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
    return process.env.REACT_APP_API_BASE_URL || defaultUrl;
  };
}

export class AdminAPI extends ApiBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://api-feature.mybasepay.com", baseUrl);
    }

    /**
     * Billing information
     * @param companyId (optional) 
     * @return Success
     */
    getCorporateBillingInfo(companyId: string | undefined): Promise<ProfileCorporateBillingInfoModel> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/billing-info?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateBillingInfo(_response);
        });
    }

    protected processGetCorporateBillingInfo(response: Response): Promise<ProfileCorporateBillingInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateBillingInfoModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateBillingInfoModel>(null as any);
    }

    /**
     * Set billing information
     * @return No Content
     */
    setCorporateBillingInfo(body: AdminProfileCorporateBillingInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/billing-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporateBillingInfo(_response);
        });
    }

    protected processSetCorporateBillingInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * PrimaryContacts information
     * @param companyId (optional) 
     * @return Success
     */
    getCorporatePrimaryContacts(companyId: string | undefined): Promise<ProfileCorporatePrimaryContactInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/primary-contacts?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporatePrimaryContacts(_response);
        });
    }

    protected processGetCorporatePrimaryContacts(response: Response): Promise<ProfileCorporatePrimaryContactInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporatePrimaryContactInfoModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporatePrimaryContactInfoModel[]>(null as any);
    }

    /**
     * Set primary contacts information
     * @return No Content
     */
    setCorporatePrimaryContactsInfo(body: AdminProfileCorporatePrimaryContactsInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/primary-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporatePrimaryContactsInfo(_response);
        });
    }

    protected processSetCorporatePrimaryContactsInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Defines whether this contact is used in any active assignment
     * @return Success
     */
    contactHasActiveAssignmentRelation(contactId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/contacts/{contactId}/has-active-assignment";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactHasActiveAssignmentRelation(_response);
        });
    }

    protected processContactHasActiveAssignmentRelation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Supervisors information
     * @param companyId (optional) 
     * @return Success
     */
    getCorporateSupervisors(companyId: string | undefined): Promise<ProfileCorporateSupervisorInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/supervisors?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateSupervisors(_response);
        });
    }

    protected processGetCorporateSupervisors(response: Response): Promise<ProfileCorporateSupervisorInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateSupervisorInfoModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateSupervisorInfoModel[]>(null as any);
    }

    /**
     * Set supervisors information
     * @return No Content
     */
    setCorporateSupervisorsInfo(body: AdminProfileCorporateSupervisorsInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/supervisors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporateSupervisorsInfo(_response);
        });
    }

    protected processSetCorporateSupervisorsInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * TimesheetApprovers information
     * @param companyId (optional) 
     * @return Success
     */
    getCorporateTimesheetApprovers(companyId: string | undefined): Promise<ProfileCorporateTimesheetApproverInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/timesheet-approvers?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateTimesheetApprovers(_response);
        });
    }

    protected processGetCorporateTimesheetApprovers(response: Response): Promise<ProfileCorporateTimesheetApproverInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateTimesheetApproverInfoModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateTimesheetApproverInfoModel[]>(null as any);
    }

    /**
     * Set timesheetApprovers information
     * @return No Content
     */
    setCorporateTimesheetApproversInfo(body: AdminProfileCorporateTimesheetApproversInfoModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/settings/corporate-ta/timesheet-approvers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCorporateTimesheetApproversInfo(_response);
        });
    }

    protected processSetCorporateTimesheetApproversInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * ACHPayments
     * @param pageNumber (optional) 
     * @return Success
     */
    getACHPayments(pageNumber: number | undefined): Promise<ACHPaymentsPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/achpayment/aCHPayments?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetACHPayments(_response);
        });
    }

    protected processGetACHPayments(response: Response): Promise<ACHPaymentsPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ACHPaymentsPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ACHPaymentsPagedResponseModel>(null as any);
    }

    /**
     * Get ACHPayment File
     * @param id (optional) 
     * @return Success
     */
    getACHPaymentFile(id: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/achpayment/download/achpayment-file?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetACHPaymentFile(_response);
        });
    }

    protected processGetACHPaymentFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload achpayment file
     * @param document_ext Extension for file txt
     * @return Success
     */
    getACHPaymentFileUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/achpayment/upload/achpayment-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetACHPaymentFileUploadLink(_response);
        });
    }

    protected processGetACHPaymentFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * ACHPayment
     * @param body (optional) 
     * @return Success
     */
    createACHPayment(body: ACHPaymentRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/achpayment/achpayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateACHPayment(_response);
        });
    }

    protected processCreateACHPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get AccountNumbers
     * @return Success
     */
    getAccountNumbers(): Promise<string[]> {
        let url_ = this.baseUrl + "/backoffice/admin/achpayment/accountNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountNumbers(_response);
        });
    }

    protected processGetAccountNumbers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Add AccountNumber to Payment
     * @param body (optional) 
     * @return Success
     */
    addAccountNumberToPayment(body: AddAccountNumberRequestModel | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/backoffice/admin/achpayment/addAccountNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAccountNumberToPayment(_response);
        });
    }

    protected processAddAccountNumberToPayment(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Assignments
     * @param page_number (optional) 
     * @param assignment_name (optional) 
     * @param assignment_statuses (optional) 
     * @param assignment_stage (optional) 
     * @param company_uuids (optional) 
     * @param customer_ids (optional) 
     * @param worker_ids (optional) 
     * @param assignment_termination_reasons (optional) 
     * @param created_date_start (optional) 
     * @param created_date_end (optional) 
     * @param worker_types (optional) 
     * @return Success
     */
    getAssignmentsPagedList(page_number: number | undefined, assignment_name: string | undefined, assignment_statuses: AssignmentStatusTypeEnum[] | undefined, assignment_stage: AssignmentStageFilterEnum | undefined, company_uuids: string[] | undefined, customer_ids: string[] | undefined, worker_ids: string[] | undefined, assignment_termination_reasons: AssignmentTerminationReasonTypeEnum[] | undefined, created_date_start: Date | undefined, created_date_end: Date | undefined, worker_types: WorkerTypeEnum[] | undefined): Promise<AdminPagedAssignmentResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments?";
        if (page_number === null)
            throw new Error("The parameter 'page_number' cannot be null.");
        else if (page_number !== undefined)
            url_ += "page-number=" + encodeURIComponent("" + page_number) + "&";
        if (assignment_name === null)
            throw new Error("The parameter 'assignment_name' cannot be null.");
        else if (assignment_name !== undefined)
            url_ += "assignment-name=" + encodeURIComponent("" + assignment_name) + "&";
        if (assignment_statuses === null)
            throw new Error("The parameter 'assignment_statuses' cannot be null.");
        else if (assignment_statuses !== undefined)
            assignment_statuses && assignment_statuses.forEach(item => { url_ += "assignment-statuses=" + encodeURIComponent("" + item) + "&"; });
        if (assignment_stage === null)
            throw new Error("The parameter 'assignment_stage' cannot be null.");
        else if (assignment_stage !== undefined)
            url_ += "assignment-stage=" + encodeURIComponent("" + assignment_stage) + "&";
        if (company_uuids === null)
            throw new Error("The parameter 'company_uuids' cannot be null.");
        else if (company_uuids !== undefined)
            company_uuids && company_uuids.forEach(item => { url_ += "company-uuids=" + encodeURIComponent("" + item) + "&"; });
        if (customer_ids === null)
            throw new Error("The parameter 'customer_ids' cannot be null.");
        else if (customer_ids !== undefined)
            customer_ids && customer_ids.forEach(item => { url_ += "customer-ids=" + encodeURIComponent("" + item) + "&"; });
        if (worker_ids === null)
            throw new Error("The parameter 'worker_ids' cannot be null.");
        else if (worker_ids !== undefined)
            worker_ids && worker_ids.forEach(item => { url_ += "worker-ids=" + encodeURIComponent("" + item) + "&"; });
        if (assignment_termination_reasons === null)
            throw new Error("The parameter 'assignment_termination_reasons' cannot be null.");
        else if (assignment_termination_reasons !== undefined)
            assignment_termination_reasons && assignment_termination_reasons.forEach(item => { url_ += "assignment-termination-reasons=" + encodeURIComponent("" + item) + "&"; });
        if (created_date_start === null)
            throw new Error("The parameter 'created_date_start' cannot be null.");
        else if (created_date_start !== undefined)
            url_ += "created-date-start=" + encodeURIComponent(created_date_start ? "" + created_date_start.toISOString() : "") + "&";
        if (created_date_end === null)
            throw new Error("The parameter 'created_date_end' cannot be null.");
        else if (created_date_end !== undefined)
            url_ += "created-date-end=" + encodeURIComponent(created_date_end ? "" + created_date_end.toISOString() : "") + "&";
        if (worker_types === null)
            throw new Error("The parameter 'worker_types' cannot be null.");
        else if (worker_types !== undefined)
            worker_types && worker_types.forEach(item => { url_ += "worker-types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsPagedList(_response);
        });
    }

    protected processGetAssignmentsPagedList(response: Response): Promise<AdminPagedAssignmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminPagedAssignmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminPagedAssignmentResponseModel>(null as any);
    }

    /**
     * Assignment detail
     * @return Success
     */
    getAssignmentDetail(assignmentId: string): Promise<AssignmentInfoAdminResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentDetail(_response);
        });
    }

    protected processGetAssignmentDetail(response: Response): Promise<AssignmentInfoAdminResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentInfoAdminResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInfoAdminResponseModel>(null as any);
    }

    /**
     * Assignment detail
     * @return Success
     */
    getAssignmentDetailByKey(assignmentKey: string): Promise<AssignmentInfoAdminResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/key:{assignmentKey}/info";
        if (assignmentKey === undefined || assignmentKey === null)
            throw new Error("The parameter 'assignmentKey' must be defined.");
        url_ = url_.replace("{assignmentKey}", encodeURIComponent("" + assignmentKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentDetailByKey(_response);
        });
    }

    protected processGetAssignmentDetailByKey(response: Response): Promise<AssignmentInfoAdminResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentInfoAdminResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentInfoAdminResponseModel>(null as any);
    }

    /**
     * Assignment merge edit model
     * @return Success
     */
    getAssignmentEditModel(assignmentId: string): Promise<AssignmentEditAdminResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/edit";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentEditModel(_response);
        });
    }

    protected processGetAssignmentEditModel(response: Response): Promise<AssignmentEditAdminResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentEditAdminResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentEditAdminResponseModel>(null as any);
    }

    /**
     * Update Assignment primary document
     * @param assignmentId Assignment UUID
     * @return Success
     */
    updateAssignmentPrimaryDocument(assignmentId: string, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentPrimaryDocument(_response);
        });
    }

    protected processUpdateAssignmentPrimaryDocument(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Assignment admin data edit model
     * @return Success
     */
    getAssignmentAdminDocumentEditModel(assignmentId: string): Promise<AssignmentAdminDocumentModel> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/admin-data/edit";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentAdminDocumentEditModel(_response);
        });
    }

    protected processGetAssignmentAdminDocumentEditModel(response: Response): Promise<AssignmentAdminDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentAdminDocumentModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentAdminDocumentModel>(null as any);
    }

    /**
     * Update Assignment admin data
     * @param assignmentId Assignment UUID
     * @return Success
     */
    updateAssignmentAdminDocument(assignmentId: string, body: AssignmentAdminDocumentModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/admin-data";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentAdminDocument(_response);
        });
    }

    protected processUpdateAssignmentAdminDocument(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Get list companies
     * @param assignmentStatuses (optional) 
     * @return Success
     */
    getAssignmentsCompanies(assignmentStatuses: AssignmentStatusTypeEnum[] | undefined): Promise<CompanySelectModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/companies?";
        if (assignmentStatuses === null)
            throw new Error("The parameter 'assignmentStatuses' cannot be null.");
        else if (assignmentStatuses !== undefined)
            assignmentStatuses && assignmentStatuses.forEach(item => { url_ += "assignmentStatuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsCompanies(_response);
        });
    }

    protected processGetAssignmentsCompanies(response: Response): Promise<CompanySelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySelectModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySelectModel[]>(null as any);
    }

    /**
     * Approve Step
     * @param body (optional) 
     * @return Success
     */
    assignmentApproveStep(body: AssignmentApproveStepModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/approve-step";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignmentApproveStep(_response);
        });
    }

    protected processAssignmentApproveStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Member questionnaire stage.
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return Success
     */
    fillAssignmentQuestionnaireData(assignmentId: string, body: AssignmentQuestionnaireInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/questionnaire/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFillAssignmentQuestionnaireData(_response);
        });
    }

    protected processFillAssignmentQuestionnaireData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Member questionnaire stage.
     * @param assignmentId Assignment UUID
     * @return Success
     */
    sendNotificationQuestionnaire(assignmentId: string): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/questionnaire/{assignmentId}/notify";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendNotificationQuestionnaire(_response);
        });
    }

    protected processSendNotificationQuestionnaire(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Contractor questionnaire stage.
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return Success
     */
    fillContractorQuestionnaireData(assignmentId: string, body: AssignmentQuestionnaireInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/contractor-questionnaire/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFillContractorQuestionnaireData(_response);
        });
    }

    protected processFillContractorQuestionnaireData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * GetTeammatesWithParent
     * @param companyId (optional) 
     * @return Success
     */
    getTeammatesWithParent(companyId: string | undefined): Promise<SelectTeammateViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/teammates-with-parent?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeammatesWithParent(_response);
        });
    }

    protected processGetTeammatesWithParent(response: Response): Promise<SelectTeammateViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SelectTeammateViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectTeammateViewModel[]>(null as any);
    }

    /**
     * Contractor questionnaire stage.
     * @param assignmentId Assignment UUID
     * @return Success
     */
    sendContractorNotificationQuestionnaire(assignmentId: string): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/contractor-questionnaire/{assignmentId}/notify";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendContractorNotificationQuestionnaire(_response);
        });
    }

    protected processSendContractorNotificationQuestionnaire(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Member questionnaire update.
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return Success
     */
    updateAssignmentQuestionnaireData(assignmentId: string, body: AssignmentQuestionnaireInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/questionnaire/{assignmentId}/update";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentQuestionnaireData(_response);
        });
    }

    protected processUpdateAssignmentQuestionnaireData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Contractor questionnaire update.
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return Success
     */
    updateContractorQuestionnaireData(assignmentId: string, body: AssignmentQuestionnaireInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/contractor-questionnaire/{assignmentId}/update";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContractorQuestionnaireData(_response);
        });
    }

    protected processUpdateContractorQuestionnaireData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment detail excel.
     * @param assignmentId Assignment UUID
     * @return Success
     */
    getAssignmentsDetailExcel(assignmentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/detail/excel";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsDetailExcel(_response);
        });
    }

    protected processGetAssignmentsDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Assignment update schedulers
     * @param assignmentId Assignment UUID
     * @param body (optional) 
     * @return Success
     */
    updateFinanticalSchedulerInfo(assignmentId: string, body: AssignmentFinancialSchedulerEditModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/update-scheduler-info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFinanticalSchedulerInfo(_response);
        });
    }

    protected processUpdateFinanticalSchedulerInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment remove schedulers
     * @param assignmentId Assignment UUID
     * @return Success
     */
    removeFinanticalSchedulerInfo(assignmentId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/{assignmentId}/remove-scheduler-info";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveFinanticalSchedulerInfo(_response);
        });
    }

    protected processRemoveFinanticalSchedulerInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assignment termination model
     * @return Success
     */
    getAssignmentTerminationModel(assignmentId: string): Promise<AssignmentTerminationModel> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/termination/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTerminationModel(_response);
        });
    }

    protected processGetAssignmentTerminationModel(response: Response): Promise<AssignmentTerminationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentTerminationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentTerminationModel>(null as any);
    }

    /**
     * Delete Assignment Termination
     * @return Success
     */
    deleteAssignmentTermination(assignmentId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/termination/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssignmentTermination(_response);
        });
    }

    protected processDeleteAssignmentTermination(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new Assignment Termination
     * @return Success
     */
    createNewAssignmentTermination(body: AssignmentTerminationCreateUpdateApiModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/termination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewAssignmentTermination(_response);
        });
    }

    protected processCreateNewAssignmentTermination(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Assignment Termination
     * @return Success
     */
    updateAssignmentTermination(body: AssignmentTerminationCreateUpdateApiModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/termination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentTermination(_response);
        });
    }

    protected processUpdateAssignmentTermination(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get link and key for upload file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getAssignmentTerminationAttachmentUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/attachment/upload?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTerminationAttachmentUploadLink(_response);
        });
    }

    protected processGetAssignmentTerminationAttachmentUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get assignment termination attachment file
     * @param assignmentId Assignment UUID
     * @return Success
     */
    getAssignmentTerminationAttachmentFile(assignmentId: string): Promise<ResourceDownloadResponse[]> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/termination/{assignmentId}/download/attachment";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTerminationAttachmentFile(_response);
        });
    }

    protected processGetAssignmentTerminationAttachmentFile(response: Response): Promise<ResourceDownloadResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse[]>(null as any);
    }

    /**
     * Get attachment file
     * @param fileKey (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getAssignmentAttachmentFile(fileKey: string | undefined, fileName: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/attachment/download?";
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentAttachmentFile(_response);
        });
    }

    protected processGetAssignmentAttachmentFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * AssignmentsExcel
     * @return Success
     */
    getAssignmentsListExcel(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/excel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentsListExcel(_response);
        });
    }

    protected processGetAssignmentsListExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Renew Assignment with changes
     * @return Success
     */
    renewAssignmentWithChanges(body: RenewAssignmentWithChangesRequest): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/renew/with-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewAssignmentWithChanges(_response);
        });
    }

    protected processRenewAssignmentWithChanges(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Rehire Assignment with changes
     * @return Success
     */
    rehireAssignmentWithChanges(renewKind: RenewKindEnum, body: AssignmentPrimaryDocumentEditModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/rehire/with-changes?";
        if (renewKind === undefined || renewKind === null)
            throw new Error("The parameter 'renewKind' must be defined and cannot be null.");
        else
            url_ += "renewKind=" + encodeURIComponent("" + renewKind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRehireAssignmentWithChanges(_response);
        });
    }

    protected processRehireAssignmentWithChanges(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * Renew Assignment without changes
     * @return Success
     */
    renewAssignmentWithoutChanges(body: RenewAssignmentModel): Promise<CreateAssignmentResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/assignments/renew/without-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewAssignmentWithoutChanges(_response);
        });
    }

    protected processRenewAssignmentWithoutChanges(response: Response): Promise<CreateAssignmentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAssignmentResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAssignmentResponse>(null as any);
    }

    /**
     * BOUsers
     * @param page_number (optional) Page number
     * @param userName (optional) 
     * @param requestType (optional) RequestType filter
     * @param member_type (optional) Member type filter
     * @param profile_types (optional) Profile types filter
     * @return Success
     */
    getBOUsersPagedList(page_number: number | undefined, userName: string | undefined, requestType: BOUserRequestStatusEnum | undefined, member_type: BOUserTypeFilterEnum | undefined, profile_types: ProfileTypeEnum[] | undefined): Promise<BOUserListResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers?";
        if (page_number === null)
            throw new Error("The parameter 'page_number' cannot be null.");
        else if (page_number !== undefined)
            url_ += "page-number=" + encodeURIComponent("" + page_number) + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (member_type === null)
            throw new Error("The parameter 'member_type' cannot be null.");
        else if (member_type !== undefined)
            url_ += "member-type=" + encodeURIComponent("" + member_type) + "&";
        if (profile_types === null)
            throw new Error("The parameter 'profile_types' cannot be null.");
        else if (profile_types !== undefined)
            profile_types && profile_types.forEach(item => { url_ += "profile-types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBOUsersPagedList(_response);
        });
    }

    protected processGetBOUsersPagedList(response: Response): Promise<BOUserListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOUserListResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOUserListResponseModel>(null as any);
    }

    /**
     * BOUsersExcel
     * @param page_number (optional) Page number
     * @param userName (optional) 
     * @param requestType (optional) RequestType filter
     * @param member_type (optional) Member type filter
     * @param profile_types (optional) Profile types filter
     * @return Success
     */
    getBOUsersExcel(page_number: number | undefined, userName: string | undefined, requestType: BOUserRequestStatusEnum | undefined, member_type: BOUserTypeFilterEnum | undefined, profile_types: ProfileTypeEnum[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/all/excel?";
        if (page_number === null)
            throw new Error("The parameter 'page_number' cannot be null.");
        else if (page_number !== undefined)
            url_ += "page-number=" + encodeURIComponent("" + page_number) + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (member_type === null)
            throw new Error("The parameter 'member_type' cannot be null.");
        else if (member_type !== undefined)
            url_ += "member-type=" + encodeURIComponent("" + member_type) + "&";
        if (profile_types === null)
            throw new Error("The parameter 'profile_types' cannot be null.");
        else if (profile_types !== undefined)
            profile_types && profile_types.forEach(item => { url_ += "profile-types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBOUsersExcel(_response);
        });
    }

    protected processGetBOUsersExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * BOAccount
     * @param userId Member UUID
     * @return Success
     */
    getBOAccountByUserId(userId: string): Promise<FullBOUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{userId}/profile";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBOAccountByUserId(_response);
        });
    }

    protected processGetBOAccountByUserId(response: Response): Promise<FullBOUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullBOUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullBOUserResponseModel>(null as any);
    }

    /**
     * BOAccount
     * @param userKey User Key
     * @return Success
     */
    getBOAccountByUserKey(userKey: string): Promise<FullBOUserResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{userKey}/profile";
        if (userKey === undefined || userKey === null)
            throw new Error("The parameter 'userKey' must be defined.");
        url_ = url_.replace("{userKey}", encodeURIComponent("" + userKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBOAccountByUserKey(_response);
        });
    }

    protected processGetBOAccountByUserKey(response: Response): Promise<FullBOUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullBOUserResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullBOUserResponseModel>(null as any);
    }

    /**
     * create PriceAgreement
     * @param body (optional) 
     * @return Success
     */
    createBOUsersPriceAgreement(body: BOUsersPriceAgreementModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/price-agreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBOUsersPriceAgreement(_response);
        });
    }

    protected processCreateBOUsersPriceAgreement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * ApproveStep
     * @param body (optional) 
     * @return Success
     */
    approveStep(body: BOUsersApproveStepModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/approve-step";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveStep(_response);
        });
    }

    protected processApproveStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get link and key for upload price agreement file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getPriceAgreementUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/upload/price-agreement-link?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPriceAgreementUploadLink(_response);
        });
    }

    protected processGetPriceAgreementUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Filled initial setup profiles emails
     * @return Success
     */
    getRegisteredMembersEmailAndFullName(): Promise<BOUserNotificationModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/registered";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegisteredMembersEmailAndFullName(_response);
        });
    }

    protected processGetRegisteredMembersEmailAndFullName(response: Response): Promise<BOUserNotificationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOUserNotificationModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOUserNotificationModel[]>(null as any);
    }

    /**
     * Get history file by key
     * @param userId (optional) 
     * @param fileKey (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    getHistoryFileByKey(userId: string | undefined, fileKey: string | undefined, documentType: AccountDocumentTypeEnum | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/download/history-files?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoryFileByKey(_response);
        });
    }

    protected processGetHistoryFileByKey(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get Price Agreement file
     * @param userId User UUID
     * @param fileKey (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getPriceAgreementFile(userId: string, fileKey: string | undefined, fileName: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/download/price-agreement/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPriceAgreementFile(_response);
        });
    }

    protected processGetPriceAgreementFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get EntityInfo file
     * @param userId (optional) 
     * @return Success
     */
    getEntityInfoFile(userId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/download/entity-info-file?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntityInfoFile(_response);
        });
    }

    protected processGetEntityInfoFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload EntityInfo file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @param userId (optional) 
     * @return Success
     */
    getEntityInfoFileUploadLink(document_ext: string, userId: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/upload/entity-info-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntityInfoFileUploadLink(_response);
        });
    }

    protected processGetEntityInfoFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get BankingInfo file
     * @param userId (optional) 
     * @return Success
     */
    getBankingInfoFile(userId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/download/banking-info-file?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankingInfoFile(_response);
        });
    }

    protected processGetBankingInfoFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload BankingInfo file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @param userId (optional) 
     * @return Success
     */
    getBankingInfoFileUploadLink(document_ext: string, userId: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/upload/banking-info-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankingInfoFileUploadLink(_response);
        });
    }

    protected processGetBankingInfoFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * get Users With Partners Data
     * @param isRegisteredInMp (optional) 
     * @return Success
     */
    getUsersWithPartnersData(isRegisteredInMp: boolean | undefined): Promise<PersonSelectModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/users-with-partners?";
        if (isRegisteredInMp === null)
            throw new Error("The parameter 'isRegisteredInMp' cannot be null.");
        else if (isRegisteredInMp !== undefined)
            url_ += "isRegisteredInMp=" + encodeURIComponent("" + isRegisteredInMp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsersWithPartnersData(_response);
        });
    }

    protected processGetUsersWithPartnersData(response: Response): Promise<PersonSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSelectModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSelectModel[]>(null as any);
    }

    /**
     * Banking Information
     * @param companyId (optional) 
     * @return Success
     */
    getBankingInformation(companyId: string | undefined): Promise<BankingInformationResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/banking-information?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankingInformation(_response);
        });
    }

    protected processGetBankingInformation(response: Response): Promise<BankingInformationResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankingInformationResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankingInformationResponseModel>(null as any);
    }

    /**
     * Banking Information
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBankingInformation(body: CompanyBankingInformationRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/banking-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdateBankingInformation(_response);
        });
    }

    protected processCreateOrUpdateBankingInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Entity Information
     * @param companyId (optional) 
     * @return Success
     */
    getEntityInformation(companyId: string | undefined): Promise<EntityInformationResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/entity-information?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntityInformation(_response);
        });
    }

    protected processGetEntityInformation(response: Response): Promise<EntityInformationResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityInformationResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityInformationResponseModel>(null as any);
    }

    /**
     * entity Information
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEntityInformation(body: EntityInformationRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/entity-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdateEntityInformation(_response);
        });
    }

    protected processCreateOrUpdateEntityInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update international profile
     * @param body (optional) 
     * @return Success
     */
    updateInternationalProfile(body: InternationalRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/international";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInternationalProfile(_response);
        });
    }

    protected processUpdateInternationalProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update company profile
     * @param body (optional) 
     * @return Success
     */
    updateCompanyProfile(body: CompanyRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCompanyProfile(_response);
        });
    }

    protected processUpdateCompanyProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update selfEmployee profile
     * @param body (optional) 
     * @return Success
     */
    updateSelfEmployeeProfile(body: SelfEmployedRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/self-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSelfEmployeeProfile(_response);
        });
    }

    protected processUpdateSelfEmployeeProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * PrimaryContacts information for member
     * @return Success
     */
    getCorporatePrimaryContactsForMember(companyId: string): Promise<ProfileCorporatePrimaryContactInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{companyId}/corporate-ta/primary-contacts";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporatePrimaryContactsForMember(_response);
        });
    }

    protected processGetCorporatePrimaryContactsForMember(response: Response): Promise<ProfileCorporatePrimaryContactInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporatePrimaryContactInfoModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporatePrimaryContactInfoModel[]>(null as any);
    }

    /**
     * Supervisors information for member
     * @return Success
     */
    getCorporateSupervisorsForMember(companyId: string): Promise<ProfileCorporateSupervisorInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{companyId}/corporate-ta/supervisors";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateSupervisorsForMember(_response);
        });
    }

    protected processGetCorporateSupervisorsForMember(response: Response): Promise<ProfileCorporateSupervisorInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateSupervisorInfoModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateSupervisorInfoModel[]>(null as any);
    }

    /**
     * TimesheetApprovers information for member
     * @return Success
     */
    getCorporateTimesheetApproversForMember(companyId: string): Promise<ProfileCorporateTimesheetApproverInfoModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{companyId}/corporate-ta/timesheet-approvers";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateTimesheetApproversForMember(_response);
        });
    }

    protected processGetCorporateTimesheetApproversForMember(response: Response): Promise<ProfileCorporateTimesheetApproverInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileCorporateTimesheetApproverInfoModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCorporateTimesheetApproverInfoModel[]>(null as any);
    }

    /**
     * Member logo information
     * @return Success
     */
    getMemberLogoInfo(companyId: string): Promise<MemberLogoInfoViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{companyId}/settings/logo-information";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberLogoInfo(_response);
        });
    }

    protected processGetMemberLogoInfo(response: Response): Promise<MemberLogoInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberLogoInfoViewModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberLogoInfoViewModel>(null as any);
    }

    /**
     * Member logo information
     * @param body (optional) 
     * @return No Content
     */
    setMemberLogoInfo(companyId: string, body: MemberLogoInfoEditModel | undefined): Promise<MemberLogoInfoViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{companyId}/settings/logo-information";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetMemberLogoInfo(_response);
        });
    }

    protected processSetMemberLogoInfo(response: Response): Promise<MemberLogoInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberLogoInfoViewModel;
            return result204;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberLogoInfoViewModel>(null as any);
    }

    /**
     * Price Agreement
     * @return Success
     */
    getMemberPriceAgreement(companyId: string): Promise<BOUsersPriceAgreementRespModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/{companyId}/price-agreement";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberPriceAgreement(_response);
        });
    }

    protected processGetMemberPriceAgreement(response: Response): Promise<BOUsersPriceAgreementRespModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOUsersPriceAgreementRespModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOUsersPriceAgreementRespModel>(null as any);
    }

    /**
     * BOAdmins
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getBOAdminsPagedList(pageSize: number | undefined, pageNumber: number | undefined): Promise<BOAdminViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/admins?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBOAdminsPagedList(_response);
        });
    }

    protected processGetBOAdminsPagedList(response: Response): Promise<BOAdminViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOAdminViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOAdminViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get all BO Members without admin role
     * @return Success
     */
    getMembersWithoutAdminRoleShort(): Promise<BOMemberShortViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/get-BOMembers-without-admin-role";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMembersWithoutAdminRoleShort(_response);
        });
    }

    protected processGetMembersWithoutAdminRoleShort(response: Response): Promise<BOMemberShortViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BOMemberShortViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BOMemberShortViewModel[]>(null as any);
    }

    /**
     * Add user  admin role
     * @param userId (optional) 
     * @return Success
     */
    grantAdminRole(userId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/bousers/Grant-BO-admin-role?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGrantAdminRole(_response);
        });
    }

    protected processGrantAdminRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * member comments
     * @param pageNumber (optional) 
     * @param memberId (optional) 
     * @return Success
     */
    getMemberComments(pageNumber: number | undefined, memberId: string | undefined): Promise<MemberCommentsPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/member?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "MemberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberComments(_response);
        });
    }

    protected processGetMemberComments(response: Response): Promise<MemberCommentsPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MemberCommentsPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberCommentsPagedResponseModel>(null as any);
    }

    /**
     * Create Comment
     * @param body (optional) 
     * @return Success
     */
    createNewMemberComment(body: CreateMemberCommentRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewMemberComment(_response);
        });
    }

    protected processCreateNewMemberComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update Comment
     * @param body (optional) 
     * @return Success
     */
    updateMemberComment(body: EditMemberCommentRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMemberComment(_response);
        });
    }

    protected processUpdateMemberComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Comment
     * @param id (optional) 
     * @return Success
     */
    deleteMemberComment(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/member?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMemberComment(_response);
        });
    }

    protected processDeleteMemberComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * customer comments
     * @param pageNumber (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerComments(pageNumber: number | undefined, customerId: string | undefined): Promise<CustomerCommentsPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/customer?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerComments(_response);
        });
    }

    protected processGetCustomerComments(response: Response): Promise<CustomerCommentsPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerCommentsPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerCommentsPagedResponseModel>(null as any);
    }

    /**
     * Create Comment
     * @param body (optional) 
     * @return Success
     */
    createNewCustomerComment(body: CreateCustomerCommentRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewCustomerComment(_response);
        });
    }

    protected processCreateNewCustomerComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update Comment
     * @param body (optional) 
     * @return Success
     */
    updateCustomerComment(body: EditCustomerCommentRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerComment(_response);
        });
    }

    protected processUpdateCustomerComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Comment
     * @param id (optional) 
     * @return Success
     */
    deleteCustomerComment(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/customer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCustomerComment(_response);
        });
    }

    protected processDeleteCustomerComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * assignment comments
     * @param pageNumber (optional) 
     * @param assignmentId (optional) 
     * @return Success
     */
    getAssignmentComments(pageNumber: number | undefined, assignmentId: string | undefined): Promise<AssignmentCommentsPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/assignment?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "AssignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentComments(_response);
        });
    }

    protected processGetAssignmentComments(response: Response): Promise<AssignmentCommentsPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentCommentsPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentCommentsPagedResponseModel>(null as any);
    }

    /**
     * Create Comment
     * @param body (optional) 
     * @return Success
     */
    createNewAssignmentComment(body: CreateAssignmentCommentRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewAssignmentComment(_response);
        });
    }

    protected processCreateNewAssignmentComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update Comment
     * @param body (optional) 
     * @return Success
     */
    updateAssignmentComment(body: EditAssignmentCommentRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssignmentComment(_response);
        });
    }

    protected processUpdateAssignmentComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Comment
     * @param id (optional) 
     * @return Success
     */
    deleteAssignmentComment(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/comments/assignment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssignmentComment(_response);
        });
    }

    protected processDeleteAssignmentComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get list of Contractor companies
     * @param pageNumber (optional) 
     * @param contractorCompanyName (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getContractorCompaniesPagedList(pageNumber: number | undefined, contractorCompanyName: string | undefined, companyIds: string[] | undefined): Promise<ContractorCompanyItemViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (contractorCompanyName === null)
            throw new Error("The parameter 'contractorCompanyName' cannot be null.");
        else if (contractorCompanyName !== undefined)
            url_ += "ContractorCompanyName=" + encodeURIComponent("" + contractorCompanyName) + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompaniesPagedList(_response);
        });
    }

    protected processGetContractorCompaniesPagedList(response: Response): Promise<ContractorCompanyItemViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyItemViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyItemViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get contractor companies for member
     * @return Success
     */
    getContractorCompaniesForMember(companyId: string): Promise<ContractorCompanyModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompaniesForMember(_response);
        });
    }

    protected processGetContractorCompaniesForMember(response: Response): Promise<ContractorCompanyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyModel[]>(null as any);
    }

    /**
     * Get contractor company detail by id
     * @return Success
     */
    getContractorCompanyDetailById(contractorCompanyId: string): Promise<ContractorCompanyDetailAdminViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/{contractorCompanyId}";
        if (contractorCompanyId === undefined || contractorCompanyId === null)
            throw new Error("The parameter 'contractorCompanyId' must be defined.");
        url_ = url_.replace("{contractorCompanyId}", encodeURIComponent("" + contractorCompanyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyDetailById(_response);
        });
    }

    protected processGetContractorCompanyDetailById(response: Response): Promise<ContractorCompanyDetailAdminViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyDetailAdminViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyDetailAdminViewModel>(null as any);
    }

    /**
     * Get contractor company detail by key
     * @return Success
     */
    getContractorCompanyDetailByKey(contractorCompanyKey: string): Promise<ContractorCompanyDetailAdminViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/{contractorCompanyKey}";
        if (contractorCompanyKey === undefined || contractorCompanyKey === null)
            throw new Error("The parameter 'contractorCompanyKey' must be defined.");
        url_ = url_.replace("{contractorCompanyKey}", encodeURIComponent("" + contractorCompanyKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyDetailByKey(_response);
        });
    }

    protected processGetContractorCompanyDetailByKey(response: Response): Promise<ContractorCompanyDetailAdminViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractorCompanyDetailAdminViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractorCompanyDetailAdminViewModel>(null as any);
    }

    /**
     * Get Contractor company file
     * @param workerId (optional) 
     * @return Success
     */
    getContractorCompanyFile(workerId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/download/contractor-company-file?";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyFile(_response);
        });
    }

    protected processGetContractorCompanyFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload Contractor company file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @param workerId (optional) 
     * @return Success
     */
    getContractorCompanyFileUploadLink(document_ext: string, workerId: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/upload/contractor-company-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractorCompanyFileUploadLink(_response);
        });
    }

    protected processGetContractorCompanyFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get list companies
     * @return Success
     */
    getMembersWithContractorCompany(): Promise<CompanySelectModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMembersWithContractorCompany(_response);
        });
    }

    protected processGetMembersWithContractorCompany(response: Response): Promise<CompanySelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySelectModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySelectModel[]>(null as any);
    }

    /**
     * Get history contractor companies file
     * @param id (optional) 
     * @param fileKey (optional) 
     * @return Success
     */
    getHistoryContractorCompaniesFile(id: string | undefined, fileKey: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/download/history-contractor-companies-file?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "fileKey=" + encodeURIComponent("" + fileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoryContractorCompaniesFile(_response);
        });
    }

    protected processGetHistoryContractorCompaniesFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Update contractor company
     * @param contractorCompanyId contractorCompanyId UUID
     * @return Success
     */
    updateContractorCompany(contractorCompanyId: string, body: UpdateContractorCompanyModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/contractor-companies/update/{contractorCompanyId}";
        if (contractorCompanyId === undefined || contractorCompanyId === null)
            throw new Error("The parameter 'contractorCompanyId' must be defined.");
        url_ = url_.replace("{contractorCompanyId}", encodeURIComponent("" + contractorCompanyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContractorCompany(_response);
        });
    }

    protected processUpdateContractorCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationDetailsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get list of Customers
     * @param pageNumber (optional) 
     * @param status (optional) 
     * @param customerName (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getCustomersPagedList(pageNumber: number | undefined, status: CustomerStatusFilterEnum | undefined, customerName: string | undefined, companyIds: string[] | undefined): Promise<CustomerPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/customers?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (customerName === null)
            throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersPagedList(_response);
        });
    }

    protected processGetCustomersPagedList(response: Response): Promise<CustomerPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerPagedResponseModel>(null as any);
    }

    /**
     * Get list companies
     * @param filter Get companies filtered by
     * @return Success
     */
    getCompaniesWithApprovedMembersOrCustomer(filter: CustomerCompaniesFilterEnum): Promise<CompanySelectModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/companies/{filter}";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined.");
        url_ = url_.replace("{filter}", encodeURIComponent("" + filter));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompaniesWithApprovedMembersOrCustomer(_response);
        });
    }

    protected processGetCompaniesWithApprovedMembersOrCustomer(response: Response): Promise<CompanySelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySelectModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySelectModel[]>(null as any);
    }

    /**
     * Get list all companies
     * @return Success
     */
    getAllCustomersCompanies(): Promise<CompanySelectModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/all-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCustomersCompanies(_response);
        });
    }

    protected processGetAllCustomersCompanies(response: Response): Promise<CompanySelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySelectModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySelectModel[]>(null as any);
    }

    /**
     * Update existed Customer info
     * @param customerId Customer UUID
     * @return Success
     */
    updateCustomerInfo(customerId: string, body: CreateCustomerRequest): Promise<CreateCustomerResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerInfo(_response);
        });
    }

    protected processUpdateCustomerInfo(response: Response): Promise<CreateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerResponse>(null as any);
    }

    /**
     * Get info for Customer
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerInfo(customerId: string): Promise<CustomerInfoResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/info";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerInfo(_response);
        });
    }

    protected processGetCustomerInfo(response: Response): Promise<CustomerInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInfoResponseModel>(null as any);
    }

    /**
     * Get info for Customer
     * @param customerKey Customer Key
     * @return Success
     */
    getCustomerInfoByKey(customerKey: string): Promise<CustomerInfoResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerKey}/info";
        if (customerKey === undefined || customerKey === null)
            throw new Error("The parameter 'customerKey' must be defined.");
        url_ = url_.replace("{customerKey}", encodeURIComponent("" + customerKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerInfoByKey(_response);
        });
    }

    protected processGetCustomerInfoByKey(response: Response): Promise<CustomerInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInfoResponseModel>(null as any);
    }

    /**
     * Get edit model for Customer
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerEditModel(customerId: string): Promise<CustomerEditResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/edit";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerEditModel(_response);
        });
    }

    protected processGetCustomerEditModel(response: Response): Promise<CustomerEditResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerEditResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerEditResponse>(null as any);
    }

    /**
     * Get list of Customers
     * @return Success
     */
    getCustomerListForMember(companyId: string): Promise<CustomerResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/by/status/non-draft/for/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerListForMember(_response);
        });
    }

    protected processGetCustomerListForMember(response: Response): Promise<CustomerResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerResponseModel[]>(null as any);
    }

    /**
     * Get Agreement details file
     * @param customerId Customer UUID
     * @param fileKey (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    getCustomerAgreementDetailsFile(customerId: string, fileKey: string | undefined, fileName: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/download/agreement-details?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerAgreementDetailsFile(_response);
        });
    }

    protected processGetCustomerAgreementDetailsFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload agreement file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getCustomerAgreementUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/upload/agreement-link?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerAgreementUploadLink(_response);
        });
    }

    protected processGetCustomerAgreementUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Approve Step
     * @param body (optional) 
     * @return Success
     */
    customerApproveStep(body: CustomerApproveStepModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/approve-step";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCustomerApproveStep(_response);
        });
    }

    protected processCustomerApproveStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get link and key for upload certificate of insurance created
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getCustomerCertificateOfInsuranceCreatedLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/upload/certificate-of-insurance-created?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerCertificateOfInsuranceCreatedLink(_response);
        });
    }

    protected processGetCustomerCertificateOfInsuranceCreatedLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get link and key for upload temp to perm conversion
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getCustomerTempToPermCreatedLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/upload/temp-to-perm-conversion?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerTempToPermCreatedLink(_response);
        });
    }

    protected processGetCustomerTempToPermCreatedLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get edit model for Customer
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerEditAdditionalInfo(customerId: string): Promise<CustomerAdditionalInfoResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/additional-info";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerEditAdditionalInfo(_response);
        });
    }

    protected processGetCustomerEditAdditionalInfo(response: Response): Promise<CustomerAdditionalInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerAdditionalInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerAdditionalInfoResponseModel>(null as any);
    }

    /**
     * Get certificate of insurance created file
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerCertificateOfInsuranceCreatedFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/download/additional-info/certificate-of-insurance-created";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerCertificateOfInsuranceCreatedFile(_response);
        });
    }

    protected processGetCustomerCertificateOfInsuranceCreatedFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get Temp to perm conversion file
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerTempToPermConversionFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/download/additional-info/temp-to-perm-conversion";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerTempToPermConversionFile(_response);
        });
    }

    protected processGetCustomerTempToPermConversionFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Update customer additional info
     * @param customerId Customer UUID
     * @param body (optional) 
     * @return Success
     */
    updateCustomerAdditionalInfo(customerId: string, body: CustomerAdditionalInfoModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/edit/additional-info";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerAdditionalInfo(_response);
        });
    }

    protected processUpdateCustomerAdditionalInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get customers by assignments
     * @param assignment_statuses (optional) 
     * @return Success
     */
    getCustomersByAssignments(assignment_statuses: AssignmentStatusTypeEnum[] | undefined): Promise<CustomerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/search/assignments?";
        if (assignment_statuses === null)
            throw new Error("The parameter 'assignment_statuses' cannot be null.");
        else if (assignment_statuses !== undefined)
            assignment_statuses && assignment_statuses.forEach(item => { url_ += "assignment-statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersByAssignments(_response);
        });
    }

    protected processGetCustomersByAssignments(response: Response): Promise<CustomerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerSearchResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerSearchResponseModel[]>(null as any);
    }

    /**
     * Customer detail excel.
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomersDetailExcel(customerId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/detail/excel";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersDetailExcel(_response);
        });
    }

    protected processGetCustomersDetailExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get link and key for upload file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getOnboardingDocumentationUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/upload/onboarding-documentation?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOnboardingDocumentationUploadLink(_response);
        });
    }

    protected processGetOnboardingDocumentationUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get onboarding documentation file
     * @param customerId Customer UUID
     * @param fileKey File key
     * @return Success
     */
    getCustomerOnboardingDocumentationFile(customerId: string, fileKey: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/download/onboarding-documentation?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (fileKey === undefined || fileKey === null)
            throw new Error("The parameter 'fileKey' must be defined and cannot be null.");
        else
            url_ += "fileKey=" + encodeURIComponent("" + fileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerOnboardingDocumentationFile(_response);
        });
    }

    protected processGetCustomerOnboardingDocumentationFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get SOW template file
     * @param customerId Customer UUID
     * @return Success
     */
    getSOWTemplateFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/download/sow-template";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSOWTemplateFile(_response);
        });
    }

    protected processGetSOWTemplateFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get customerhistory file by key
     * @param customerId (optional) 
     * @param fileKey (optional) 
     * @param documentType (optional) 
     * @param newOnboardingDocumentationFileKeys (optional) 
     * @return Success
     */
    getCustomerHistoryFileByKey(customerId: string | undefined, fileKey: string | undefined, documentType: CustomerDocumentTypeEnum | undefined, newOnboardingDocumentationFileKeys: string[] | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/download/customer-history-files?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (fileKey === null)
            throw new Error("The parameter 'fileKey' cannot be null.");
        else if (fileKey !== undefined)
            url_ += "FileKey=" + encodeURIComponent("" + fileKey) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        if (newOnboardingDocumentationFileKeys === null)
            throw new Error("The parameter 'newOnboardingDocumentationFileKeys' cannot be null.");
        else if (newOnboardingDocumentationFileKeys !== undefined)
            newOnboardingDocumentationFileKeys && newOnboardingDocumentationFileKeys.forEach(item => { url_ += "newOnboardingDocumentationFileKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerHistoryFileByKey(_response);
        });
    }

    protected processGetCustomerHistoryFileByKey(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for purchase order upload file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getPurchaseOrderUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/upload/purchase-order?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPurchaseOrderUploadLink(_response);
        });
    }

    protected processGetPurchaseOrderUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get purchase order file
     * @param customerId Customer UUID
     * @return Success
     */
    getCustomerPurchaseOrderFile(customerId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/customers/{customerId}/download/purchase-order";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerPurchaseOrderFile(_response);
        });
    }

    protected processGetCustomerPurchaseOrderFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Create new customer group
     * @param body (optional) 
     * @return Success
     */
    createCustomerGroup(body: CreateCustomerGroupViewModel | undefined): Promise<CustomerGroup[]> {
        let url_ = this.baseUrl + "/backoffice/admin/customerGroups/add-new-customer-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomerGroup(_response);
        });
    }

    protected processCreateCustomerGroup(response: Response): Promise<CustomerGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerGroup[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGroup[]>(null as any);
    }

    /**
     * Get customers groups list
     * @return Success
     */
    getCustomersGroupsList(): Promise<CustomerGroup[]> {
        let url_ = this.baseUrl + "/backoffice/admin/customerGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersGroupsList(_response);
        });
    }

    protected processGetCustomersGroupsList(response: Response): Promise<CustomerGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerGroup[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGroup[]>(null as any);
    }

    /**
     * Pending assignments requests
     * @return Success
     */
    getPendingAssignmentRequests(): Promise<DashboardAssignmentResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/dashboards/home/assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPendingAssignmentRequests(_response);
        });
    }

    protected processGetPendingAssignmentRequests(response: Response): Promise<DashboardAssignmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardAssignmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardAssignmentResponseModel>(null as any);
    }

    /**
     * Pending customers requests
     * @return Success
     */
    getPendingCustomersRequests(): Promise<DashboardCustomerResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/dashboards/home/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPendingCustomersRequests(_response);
        });
    }

    protected processGetPendingCustomersRequests(response: Response): Promise<DashboardCustomerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardCustomerResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardCustomerResponseModel>(null as any);
    }

    /**
     * Dashboard. Total numbers.
     * @return Success
     */
    getTotalNumbers(): Promise<GetTotalNumbersResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/dashboards/home/total-numbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTotalNumbers(_response);
        });
    }

    protected processGetTotalNumbers(response: Response): Promise<GetTotalNumbersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTotalNumbersResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTotalNumbersResponse>(null as any);
    }

    /**
     * Get homepage statistics
     * @return Success
     */
    getHomepageStatistics(): Promise<HomepageStatisticsResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/dashboards/home/statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHomepageStatistics(_response);
        });
    }

    protected processGetHomepageStatistics(response: Response): Promise<HomepageStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomepageStatisticsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HomepageStatisticsResponse>(null as any);
    }

    /**
     * Member history
     * @param companyId (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getMemberHistory(companyId: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<HistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/history/member?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberHistory(_response);
        });
    }

    protected processGetMemberHistory(response: Response): Promise<HistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Customer history
     * @param customerId (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getCustomerHistory(customerId: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<HistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/history/customer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerHistory(_response);
        });
    }

    protected processGetCustomerHistory(response: Response): Promise<HistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * worker history
     * @param workerId (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getWorkerHistory(workerId: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<HistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/history/worker?";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "WorkerId=" + encodeURIComponent("" + workerId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerHistory(_response);
        });
    }

    protected processGetWorkerHistory(response: Response): Promise<HistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * assignment history
     * @param assignmentId (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getAssignmentHistory(assignmentId: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<HistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/history/assignment?";
        if (assignmentId === null)
            throw new Error("The parameter 'assignmentId' cannot be null.");
        else if (assignmentId !== undefined)
            url_ += "AssignmentId=" + encodeURIComponent("" + assignmentId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentHistory(_response);
        });
    }

    protected processGetAssignmentHistory(response: Response): Promise<HistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Import customer list from plain table
     * @param file (optional) 
     * @return Success
     */
    importCustomerListFromPlainTable(file: FileParameter | undefined): Promise<CreateCustomerRequest[]> {
        let url_ = this.baseUrl + "/backoffice/admin/import/customer/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportCustomerListFromPlainTable(_response);
        });
    }

    protected processImportCustomerListFromPlainTable(response: Response): Promise<CreateCustomerRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerRequest[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerRequest[]>(null as any);
    }

    /**
     * Create a list of customers
     * @return Success
     */
    createCustomers(body: ImportAdminCustomerListViewModel): Promise<BulkCustomerImportResponse[]> {
        let url_ = this.baseUrl + "/backoffice/admin/import/customer/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomers(_response);
        });
    }

    protected processCreateCustomers(response: Response): Promise<BulkCustomerImportResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkCustomerImportResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkCustomerImportResponse[]>(null as any);
    }

    /**
     * Import assignment list from plain table
     * @param file (optional) 
     * @return Success
     */
    importAssignmentListFromPlainTable(file: FileParameter | undefined): Promise<AssignmentBulkImportViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/import/assignment/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportAssignmentListFromPlainTable(_response);
        });
    }

    protected processImportAssignmentListFromPlainTable(response: Response): Promise<AssignmentBulkImportViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentBulkImportViewModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentBulkImportViewModel[]>(null as any);
    }

    /**
     * Create a list of assignments
     * @return Success
     */
    createAssignments(body: AssignmentBulkImportViewModel[]): Promise<BulkAssignmentImportResponse[]> {
        let url_ = this.baseUrl + "/backoffice/admin/import/assignments/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAssignments(_response);
        });
    }

    protected processCreateAssignments(response: Response): Promise<BulkAssignmentImportResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkAssignmentImportResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkAssignmentImportResponse[]>(null as any);
    }

    /**
     * Import assignment test mapper
     * @param file (optional) 
     * @return Success
     */
    importAssignmentTestMapper(file: FileParameter | undefined): Promise<AssignmentPrimaryDocumentEditModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/import/assignment/testmapper";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportAssignmentTestMapper(_response);
        });
    }

    protected processImportAssignmentTestMapper(response: Response): Promise<AssignmentPrimaryDocumentEditModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentPrimaryDocumentEditModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentPrimaryDocumentEditModel[]>(null as any);
    }

    /**
     * Get template File
     * @return Success
     */
    getTemplateFile(typeEnum: FileTypeEnum): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/import/download/customer/template-file?";
        if (typeEnum === undefined || typeEnum === null)
            throw new Error("The parameter 'typeEnum' must be defined and cannot be null.");
        else
            url_ += "typeEnum=" + encodeURIComponent("" + typeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateFile(_response);
        });
    }

    protected processGetTemplateFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Only for prodaction one time
     * @return Success
     * @deprecated
     */
    importCustomerListFromPlainTable2(): Promise<CreateCustomerRequest[]> {
        let url_ = this.baseUrl + "/backoffice/admin/import/netsuite/trigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportCustomerListFromPlainTable2(_response);
        });
    }

    protected processImportCustomerListFromPlainTable2(response: Response): Promise<CreateCustomerRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerRequest[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerRequest[]>(null as any);
    }

    /**
     * Kronos
     * @param importType (optional) 
     * @return Success
     */
    getAssignmentImportResult(assignmentId: string, importType: KronosImportTypeEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/kronos/assignments/GetImportResult/{assignmentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (importType === null)
            throw new Error("The parameter 'importType' cannot be null.");
        else if (importType !== undefined)
            url_ += "importType=" + encodeURIComponent("" + importType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentImportResult(_response);
        });
    }

    protected processGetAssignmentImportResult(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Kronos
     * @param type (optional) 
     * @return Success
     */
    getImport(assignmentId: string, type: KronosImportTypeEnum | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/kronos/assignments/GetImport/{assignmentId}?";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImport(_response);
        });
    }

    protected processGetImport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Kronos
     * @return Success
     */
    markResponsed(assignmentId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/kronos/assignments/update-responsed/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkResponsed(_response);
        });
    }

    protected processMarkResponsed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Kronos
     * @return Success
     */
    getAssignmentImportsInfo(assignmentId: string): Promise<AssignmentToKronosInfoExistViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/kronos/assignments/GetImportsInfo/{assignmentId}";
        if (assignmentId === undefined || assignmentId === null)
            throw new Error("The parameter 'assignmentId' must be defined.");
        url_ = url_.replace("{assignmentId}", encodeURIComponent("" + assignmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentImportsInfo(_response);
        });
    }

    protected processGetAssignmentImportsInfo(response: Response): Promise<AssignmentToKronosInfoExistViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentToKronosInfoExistViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentToKronosInfoExistViewModel>(null as any);
    }

    /**
     * Get all pay rate types
     * @return Success
     */
    getPayRateTypes(): Promise<PayRateTypeModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/multirates/pay-rate-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayRateTypes(_response);
        });
    }

    protected processGetPayRateTypes(response: Response): Promise<PayRateTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayRateTypeModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayRateTypeModel[]>(null as any);
    }

    /**
     * Get all pay codes
     * @param payRateTypeId (optional) 
     * @return Success
     */
    getPayCodes(payRateTypeId: string | undefined): Promise<PayCodeModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/multirates/pay-codes?";
        if (payRateTypeId === null)
            throw new Error("The parameter 'payRateTypeId' cannot be null.");
        else if (payRateTypeId !== undefined)
            url_ += "payRateTypeId=" + encodeURIComponent("" + payRateTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayCodes(_response);
        });
    }

    protected processGetPayCodes(response: Response): Promise<PayCodeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayCodeModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayCodeModel[]>(null as any);
    }

    /**
     * Get all assignments types pay codes
     * @return Success
     */
    getAssignmentTypesPayCode(): Promise<AssignmentsTypePayCodes[]> {
        let url_ = this.baseUrl + "/backoffice/admin/multirates/assignments-pay-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssignmentTypesPayCode(_response);
        });
    }

    protected processGetAssignmentTypesPayCode(response: Response): Promise<AssignmentsTypePayCodes[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignmentsTypePayCodes[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentsTypePayCodes[]>(null as any);
    }

    /**
     * Get pay codes groups
     * @return Success
     */
    getPayCodeGroups(): Promise<PayCodesGroup[]> {
        let url_ = this.baseUrl + "/backoffice/admin/multirates/pay-code-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayCodeGroups(_response);
        });
    }

    protected processGetPayCodeGroups(response: Response): Promise<PayCodesGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayCodesGroup[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayCodesGroup[]>(null as any);
    }

    /**
     * partner statuses
     * @param pageNumber (optional) 
     * @param isRegisteredOnMP (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getPartners(pageNumber: number | undefined, isRegisteredOnMP: boolean | undefined, companyIds: string[] | undefined): Promise<PartnerPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/partners?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (isRegisteredOnMP === null)
            throw new Error("The parameter 'isRegisteredOnMP' cannot be null.");
        else if (isRegisteredOnMP !== undefined)
            url_ += "IsRegisteredOnMP=" + encodeURIComponent("" + isRegisteredOnMP) + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartners(_response);
        });
    }

    protected processGetPartners(response: Response): Promise<PartnerPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerPagedResponseModel>(null as any);
    }

    /**
     * Get partners for member
     * @return Success
     */
    getPartnerListForMember(memberId: string): Promise<PartnerResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/partners/for/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnerListForMember(_response);
        });
    }

    protected processGetPartnerListForMember(response: Response): Promise<PartnerResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerResponseModel[]>(null as any);
    }

    /**
     * Get info for Partner
     * @param partnerId Partner UUID
     * @return Success
     */
    getPartnerInfo(partnerId: string): Promise<PartnerResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/partners/{partnerId}/info";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnerInfo(_response);
        });
    }

    protected processGetPartnerInfo(response: Response): Promise<PartnerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerResponseModel>(null as any);
    }

    /**
     * Timesheet status report. Table
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param states (optional) 
     * @param customerIds (optional) 
     * @param workerIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getTimesheetStatusReportNotSubmittedDetails(pageNumber: number | undefined, pageSize: number | undefined, states: TimesheetStatusEnum[] | undefined, customerIds: string[] | undefined, workerIds: string[] | undefined, startDate: Date | undefined, endDate: Date | undefined, companyIds: string[] | undefined): Promise<TimesheetStatusReportDetailResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/timesheet/summary/timesheet-status-report/detail?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (workerIds === null)
            throw new Error("The parameter 'workerIds' cannot be null.");
        else if (workerIds !== undefined)
            workerIds && workerIds.forEach(item => { url_ += "WorkerIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimesheetStatusReportNotSubmittedDetails(_response);
        });
    }

    protected processGetTimesheetStatusReportNotSubmittedDetails(response: Response): Promise<TimesheetStatusReportDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TimesheetStatusReportDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetStatusReportDetailResponseModel>(null as any);
    }

    /**
     * Get members for timesheet status report
     * @return Success
     */
    getMembersForTimesheetStatusReport(): Promise<CompanySelectModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/timesheet/timesheet-status-report/members";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMembersForTimesheetStatusReport(_response);
        });
    }

    protected processGetMembersForTimesheetStatusReport(response: Response): Promise<CompanySelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySelectModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySelectModel[]>(null as any);
    }

    /**
     * Get workers for timesheet status report
     * @return Success
     */
    getWorkersForTimesheetStatusReport(): Promise<WorkerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/timesheet/timesheet-status-report/workers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkersForTimesheetStatusReport(_response);
        });
    }

    protected processGetWorkersForTimesheetStatusReport(response: Response): Promise<WorkerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerSearchResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerSearchResponseModel[]>(null as any);
    }

    /**
     * Get customers for timesheet status report
     * @return Success
     */
    getCustomersForTimesheetStatusReport(): Promise<CustomerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/timesheet/timesheet-status-report/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomersForTimesheetStatusReport(_response);
        });
    }

    protected processGetCustomersForTimesheetStatusReport(response: Response): Promise<CustomerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerSearchResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerSearchResponseModel[]>(null as any);
    }

    /**
     * Timesheet status report excel
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param states (optional) 
     * @param customerIds (optional) 
     * @param workerIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param companyIds (optional) 
     * @return Success
     */
    getTimesheetStatusReportDetailsExcel(pageNumber: number | undefined, pageSize: number | undefined, states: TimesheetStatusEnum[] | undefined, customerIds: string[] | undefined, workerIds: string[] | undefined, startDate: Date | undefined, endDate: Date | undefined, companyIds: string[] | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/timesheet/summary/timesheet-status-report/detail/excel?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (workerIds === null)
            throw new Error("The parameter 'workerIds' cannot be null.");
        else if (workerIds !== undefined)
            workerIds && workerIds.forEach(item => { url_ += "WorkerIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (companyIds === null)
            throw new Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimesheetStatusReportDetailsExcel(_response);
        });
    }

    protected processGetTimesheetStatusReportDetailsExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Send timesheet status report excel
     * @param body (optional) 
     * @return Success
     */
    sendTimesheetStatusReportDetailsExcel(body: SendTimesheetStatusReportDetailRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/timesheet/summary/timesheet-status-report/detail/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendTimesheetStatusReportDetailsExcel(_response);
        });
    }

    protected processSendTimesheetStatusReportDetailsExcel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all work codes simple list
     * @return Success
     */
    getAllWorkCodesSimpleList(): Promise<string[]> {
        let url_ = this.baseUrl + "/backoffice/admin/work-codes/simple-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkCodesSimpleList(_response);
        });
    }

    protected processGetAllWorkCodesSimpleList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get all work codes
     * @return Success
     */
    getAllWorkCodes(): Promise<WorkCodeModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/work-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkCodes(_response);
        });
    }

    protected processGetAllWorkCodes(response: Response): Promise<WorkCodeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkCodeModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCodeModel[]>(null as any);
    }

    /**
     * Get worker detail by id
     * @return Success
     */
    getWorkerDetailById(workerId: string): Promise<WorkerDetailAdminViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/{workerId}";
        if (workerId === undefined || workerId === null)
            throw new Error("The parameter 'workerId' must be defined.");
        url_ = url_.replace("{workerId}", encodeURIComponent("" + workerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerDetailById(_response);
        });
    }

    protected processGetWorkerDetailById(response: Response): Promise<WorkerDetailAdminViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerDetailAdminViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDetailAdminViewModel>(null as any);
    }

    /**
     * Update worker
     * @return No Content
     */
    updateWorker(workerId: string, body: CreateWorkerModel): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/{workerId}";
        if (workerId === undefined || workerId === null)
            throw new Error("The parameter 'workerId' must be defined.");
        url_ = url_.replace("{workerId}", encodeURIComponent("" + workerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorker(_response);
        });
    }

    protected processUpdateWorker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get worker detail by key
     * @return Success
     */
    getWorkerDetailByKey(workerKey: string): Promise<WorkerDetailAdminViewModel> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/{workerKey}";
        if (workerKey === undefined || workerKey === null)
            throw new Error("The parameter 'workerKey' must be defined.");
        url_ = url_.replace("{workerKey}", encodeURIComponent("" + workerKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerDetailByKey(_response);
        });
    }

    protected processGetWorkerDetailByKey(response: Response): Promise<WorkerDetailAdminViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerDetailAdminViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDetailAdminViewModel>(null as any);
    }

    /**
     * Get workers for member
     * @return Success
     */
    getWorkersForMember(companyId: string): Promise<WorkerDetailViewModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkersForMember(_response);
        });
    }

    protected processGetWorkersForMember(response: Response): Promise<WorkerDetailViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerDetailViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDetailViewModel[]>(null as any);
    }

    /**
     * Get duplicates workers paged list
     * @param workerName (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getDuplicatesWorkersPaged(workerName: string | undefined, pageNumber: number | undefined): Promise<WorkerItemDetailViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/duplicates?";
        if (workerName === null)
            throw new Error("The parameter 'workerName' cannot be null.");
        else if (workerName !== undefined)
            url_ += "workerName=" + encodeURIComponent("" + workerName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDuplicatesWorkersPaged(_response);
        });
    }

    protected processGetDuplicatesWorkersPaged(response: Response): Promise<WorkerItemDetailViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerItemDetailViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerItemDetailViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get approved workers paged list
     * @param workerName (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getApprovedWorkersPaged(workerName: string | undefined, pageNumber: number | undefined): Promise<WorkerItemDetailViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/approved?";
        if (workerName === null)
            throw new Error("The parameter 'workerName' cannot be null.");
        else if (workerName !== undefined)
            url_ += "workerName=" + encodeURIComponent("" + workerName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApprovedWorkersPaged(_response);
        });
    }

    protected processGetApprovedWorkersPaged(response: Response): Promise<WorkerItemDetailViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerItemDetailViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerItemDetailViewModelPagedResponseModel>(null as any);
    }

    /**
     * Save duplicate worker as separate
     * @return No Content
     */
    saveWorkerAsSeparate(workerId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/{workerId}/save-separate";
        if (workerId === undefined || workerId === null)
            throw new Error("The parameter 'workerId' must be defined.");
        url_ = url_.replace("{workerId}", encodeURIComponent("" + workerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveWorkerAsSeparate(_response);
        });
    }

    protected processSaveWorkerAsSeparate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Merge duplicated worker with original one
     * @return No Content
     */
    mergeWorker(workerId: string, originalWorkerId: string): Promise<void> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/{workerId}/merge-with/{originalWorkerId}";
        if (workerId === undefined || workerId === null)
            throw new Error("The parameter 'workerId' must be defined.");
        url_ = url_.replace("{workerId}", encodeURIComponent("" + workerId));
        if (originalWorkerId === undefined || originalWorkerId === null)
            throw new Error("The parameter 'originalWorkerId' must be defined.");
        url_ = url_.replace("{originalWorkerId}", encodeURIComponent("" + originalWorkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeWorker(_response);
        });
    }

    protected processMergeWorker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Worker file
     * @param workerId (optional) 
     * @return Success
     */
    getWorkerFile(workerId: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/download/worker-file?";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerFile(_response);
        });
    }

    protected processGetWorkerFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get History Worker file
     * @param workerId (optional) 
     * @param workerFileKey (optional) 
     * @return Success
     */
    getHistoryWorkerFile(workerId: string | undefined, workerFileKey: string | undefined): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/download/history-worker-file?";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        if (workerFileKey === null)
            throw new Error("The parameter 'workerFileKey' cannot be null.");
        else if (workerFileKey !== undefined)
            url_ += "workerFileKey=" + encodeURIComponent("" + workerFileKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoryWorkerFile(_response);
        });
    }

    protected processGetHistoryWorkerFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Get link and key for upload worker file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @param workerId (optional) 
     * @return Success
     */
    getWorkerFileUploadLink(document_ext: string, workerId: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/upload/worker-file?";
        if (document_ext === undefined || document_ext === null)
            throw new Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        if (workerId === null)
            throw new Error("The parameter 'workerId' cannot be null.");
        else if (workerId !== undefined)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerFileUploadLink(_response);
        });
    }

    protected processGetWorkerFileUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get worker lookups
     * @return Success
     */
    getWorkerLookups(): Promise<WorkerSearchResponseModel[]> {
        let url_ = this.baseUrl + "/backoffice/admin/workers/lookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerLookups(_response);
        });
    }

    protected processGetWorkerLookups(response: Response): Promise<WorkerSearchResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkerSearchResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerSearchResponseModel[]>(null as any);
    }
}

export interface ACHPaymentFileRequestModel {
    fileKey?: string | undefined;
    fileName?: string | undefined;
}

export interface ACHPaymentRequestModel {
    fileInfos?: ACHPaymentFileRequestModel[] | undefined;
}

export interface ACHPaymentResponseModel {
    id?: string;
    fileName?: string | undefined;
    fileKey?: string | undefined;
    uploadedOn?: Date;
}

export interface ACHPaymentsPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: ACHPaymentResponseModel[] | undefined;
}

export enum AbilityToPayEnum {
    DoNotKnow = 0,
    Low = 10,
    Fair = 20,
    High = 30,
}

export enum AccountDocumentTypeEnum {
    EntityInfo = 0,
    BankingInfo = 1,
    PriceAgreement = 2,
}

export interface AddAccountNumberRequestModel {
    paymentIds?: string[] | undefined;
    accountNumber?: string | undefined;
}

export interface AdditionalInfoModel {
    potentialHeadcount?: CustomerSizeEnum;
    averageBillRate?: number | undefined;
    estimatedValue?: number | undefined;
    estimatedType?: DurationTypeEnum;
    industryName?: string | undefined;
    haveBusinessBefore?: boolean;
    yearsInBusiness?: YearsInBusinessEnum;
    abilityToPay?: AbilityToPayEnum;
}

export interface AdminPagedAssignmentResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: AssignmentTitleInfoModel[] | undefined;
}

export interface AdminProfileCorporateBillingInfoModel {
    companyId?: string;
    billingInfo?: ProfileCorporateBillingInfoModel;
}

export interface AdminProfileCorporatePrimaryContactsInfoModel {
    companyId?: string;
    primaryContactsData?: ProfileCorporatePrimaryContactsInfoModel;
}

export interface AdminProfileCorporateSupervisorsInfoModel {
    companyId?: string;
    supervisorsData?: ProfileCorporateSupervisorsInfoModel;
}

export interface AdminProfileCorporateTimesheetApproversInfoModel {
    companyId?: string;
    timesheetApproversData?: ProfileCorporateTimesheetApproversInfoModel;
}

export enum AnticipatedScheduleTypeEnum {
    NotKnown = 0,
    From0800AmTo0500Pm = 1,
    From0700AmTo0400Pm = 2,
    From0900AmTo0600Pm = 3,
    NineEighty = 4,
    FourTen = 5,
    Other = 1024,
}

export interface AssignmentAdminAdditionalInfoModel {
    markup?: number | undefined;
    grossMarginPerHour?: number | undefined;
    grossMarginPercent?: number | undefined;
    anticipatedWeeklyCommission?: number | undefined;
    confirmationCommissionStructure?: boolean | undefined;
}

export interface AssignmentAdminDocumentModel {
    additionalInfo?: AssignmentAdminAdditionalInfoModel;
}

export interface AssignmentAdminKronosInfoModel {
    ukgStatus?: KronosInfoStatusEnum;
    failImportNumber?: number;
}

export interface AssignmentAdminTerminationKronosInfoModel {
    ukgTerminationStatus?: AssignmentTerminationToKronosEnum;
}

export interface AssignmentAnticipatedScheduleEditModel {
    fromTime?: TimePointEnum;
    fromAMPM?: TimeAMPMEnum;
    toTime?: TimePointEnum;
    toAMPM?: TimeAMPMEnum;
}

export interface AssignmentAnticipatedScheduleViewModel {
    fromTime?: TimePointEnum;
    fromAMPM?: TimeAMPMEnum;
    toTime?: TimePointEnum;
    toAMPM?: TimeAMPMEnum;
}

export interface AssignmentApproveStepModel {
    assignmentId?: string;
    currentStage?: AssignmentStageEnum;
    currentStageStatus?: StageStatusEnum;
    message?: string | undefined;
}

export interface AssignmentBillingContactEditModel {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentBillingContactViewModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentBulkImportViewModel {
    workerFileKey?: string | undefined;
    memberId?: string | undefined;
    assignmentType?: string | undefined;
    contractorCompanyCompanyName?: string | undefined;
    contractorCompanyPrimaryContactFirstName?: string | undefined;
    contractorCompanyPrimaryContactLastName?: string | undefined;
    contractorCompanyEmail?: string | undefined;
    contractorCompanyPrimaryContactPhone?: string | undefined;
    contractorCompanyTaxId?: number | undefined;
    contractorCompanyCountry?: string | undefined;
    contractorCompanyState?: string | undefined;
    contractorCompanyCity?: string | undefined;
    contractorCompanyAddress?: string | undefined;
    contractorCompanyZip?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
    workerEmail?: string | undefined;
    workerPhone?: string | undefined;
    workerType?: string | undefined;
    workerCountry?: string | undefined;
    workerState?: string | undefined;
    workerCity?: string | undefined;
    workerAddress?: string | undefined;
    workerZip?: string | undefined;
    workerTaxId?: number | undefined;
    customerKey?: string | undefined;
    primaryContactEmail?: string | undefined;
    billingContactEmail?: string | undefined;
    billingContact1FirstName?: string | undefined;
    billingContact1LastName?: string | undefined;
    billingContact1Email?: string | undefined;
    billingContact1Phone?: string | undefined;
    billingContact2FirstName?: string | undefined;
    billingContact2LastName?: string | undefined;
    billingContact2Email?: string | undefined;
    billingContact2Phone?: string | undefined;
    billingContact3FirstName?: string | undefined;
    billingContact3LastName?: string | undefined;
    billingContact3Email?: string | undefined;
    billingContact3Phone?: string | undefined;
    billingContact4FirstName?: string | undefined;
    billingContact4LastName?: string | undefined;
    billingContact4Email?: string | undefined;
    billingContact4Phone?: string | undefined;
    supervisorFirstName?: string | undefined;
    supervisorLastName?: string | undefined;
    supervisorEmail?: string | undefined;
    supervisorPhone?: string | undefined;
    supervisorTitle?: string | undefined;
    tsApprover1FirstName?: string | undefined;
    tsApprover1LastName?: string | undefined;
    tsApprover1Email?: string | undefined;
    tsApprover1Phone?: string | undefined;
    tsApprover2FirstName?: string | undefined;
    tsApprover2LastName?: string | undefined;
    tsApprover2Email?: string | undefined;
    tsApprover2Phone?: string | undefined;
    tsApprover3FirstName?: string | undefined;
    tsApprover3LastName?: string | undefined;
    tsApprover3Email?: string | undefined;
    tsApprover3Phone?: string | undefined;
    tsApprover4FirstName?: string | undefined;
    tsApprover4LastName?: string | undefined;
    tsApprover4Email?: string | undefined;
    tsApprover4Phone?: string | undefined;
    tsApprover5FirstName?: string | undefined;
    tsApprover5LastName?: string | undefined;
    tsApprover5Email?: string | undefined;
    tsApprover5Phone?: string | undefined;
    workCountry?: string | undefined;
    workState?: string | undefined;
    workCity?: string | undefined;
    workAddress?: string | undefined;
    workZip?: string | undefined;
    billingCountry?: string | undefined;
    billingState?: string | undefined;
    billingCity?: string | undefined;
    billingAddress?: string | undefined;
    billingZip?: string | undefined;
    billingEmail?: string | undefined;
    jobTitle?: string | undefined;
    employmentType?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobDescription?: string | undefined;
    jobCategory?: string | undefined;
    workCode?: string | undefined;
    anticipatedSchedule?: string | undefined;
    customerPurchaseOrderNumber?: string | undefined;
    workingLocation?: string | undefined;
    prescreeningRequired?: string | undefined;
    prescreeningBilledTo?: string | undefined;
    specialInstructions?: string | undefined;
    recruiter1Email?: string | undefined;
    recruiter1FullName?: string | undefined;
    recruiter1RateType?: string | undefined;
    recruiter1Rate?: number | undefined;
    recruiter2Email?: string | undefined;
    recruiter2FullName?: string | undefined;
    recruiter2RateType?: string | undefined;
    recruiter2Rate?: number | undefined;
    recruiter3Email?: string | undefined;
    recruiter3FullName?: string | undefined;
    recruiter3RateType?: string | undefined;
    recruiter3Rate?: number | undefined;
    recruiter4Email?: string | undefined;
    recruiter4FullName?: string | undefined;
    recruiter4RateType?: string | undefined;
    recruiter4Rate?: number | undefined;
    recruiter5Email?: string | undefined;
    recruiter5FullName?: string | undefined;
    recruiter5RateType?: string | undefined;
    recruiter5Rate?: number | undefined;
    payType?: string | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    overtime?: string | undefined;
    otBillRate?: number | undefined;
    otPayRate?: number | undefined;
    dtBillRate?: number | undefined;
    dtPayRate?: number | undefined;
    vmsMspFee?: number | undefined;
    mbpRate?: number | undefined;
    profitRate?: number | undefined;
    pr1PayRate?: number | undefined;
    pr1BillRate?: number | undefined;
    pr1PaidByMember?: string | undefined;
    pr1SpecialInstructions?: string | undefined;
    pr2PayRate?: number | undefined;
    pr2BillRate?: number | undefined;
    pr2PaidByMember?: string | undefined;
    pr2SpecialInstructions?: string | undefined;
    srPayRate?: number | undefined;
    srBillRate?: number | undefined;
    srPaidByMember?: string | undefined;
    srSpecialInstructions?: string | undefined;
    callbackPayRate?: number | undefined;
    callbackBillRate?: number | undefined;
    callbackPaidByMember?: string | undefined;
    callbackSpecialInstructions?: string | undefined;
    chargePayRate?: number | undefined;
    chargeBillRate?: number | undefined;
    chargePaidByMember?: string | undefined;
    chargeSpecialInstructions?: string | undefined;
    onCallPayRate?: number | undefined;
    onCallBillRate?: number | undefined;
    onCallPaidByMember?: string | undefined;
    onCallSpecialInstructions?: string | undefined;
    ptoPayRate?: number | undefined;
    ptoBillRate?: number | undefined;
    ptoPaidByMember?: string | undefined;
    ptoSpecialInstructions?: string | undefined;
    taBonusPayRate?: number | undefined;
    taBonusBillRate?: number | undefined;
    taBonusPaidByMember?: string | undefined;
    taBonusSpecialInstructions?: string | undefined;
    expensesWithReceiptPayRate?: number | undefined;
    expensesWithReceiptBillRate?: number | undefined;
    expensesWithReceiptPaidByMember?: string | undefined;
    expensesWithReceiptSpecialInstructions?: string | undefined;
    perDiemPayRate?: number | undefined;
    perDiemBillRate?: number | undefined;
    perDiemPaidByMember?: string | undefined;
    perDiemSpecialInstructions?: string | undefined;
    mileagePayRate?: number | undefined;
    mileageBillRate?: number | undefined;
    mileagePaidByMember?: string | undefined;
    mileageSpecialInstructions?: string | undefined;
    otherPayRate?: number | undefined;
    otherBillRate?: number | undefined;
    otherPaidByMember?: string | undefined;
    otherSpecialInstructions?: string | undefined;
    splitCompanyName?: string | undefined;
    splitRateType?: string | undefined;
    splitAmount?: number | undefined;
    splitSubcontractorRate?: number | undefined;
    splitCountry?: string | undefined;
    splitState?: string | undefined;
    splitCity?: string | undefined;
    splitAddress?: string | undefined;
    splitZip?: string | undefined;
    splitFirstName?: string | undefined;
    splitLastName?: string | undefined;
    splitEmail?: string | undefined;
    splitPhoneNumber?: string | undefined;
}

export enum AssignmentCategoryEnum {
    Recruiter = 1,
    Corporate = 2,
}

export interface AssignmentCommentViewModel {
    id?: string;
    assignmentId?: string;
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    updatedById?: string | undefined;
    updatedByFirstName?: string | undefined;
    updatedByLastName?: string | undefined;
    text?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
}

export interface AssignmentCommentsPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: AssignmentCommentViewModel[] | undefined;
}

export interface AssignmentContactPersonEditModel {
    contactId?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentContactPersonViewModel {
    id?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentContractorCompanyInfoEditModel {
    companyId?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    companyName?: string | undefined;
    location?: LocationModel;
    workerFile?: ResourceDownloadResponse;
}

export interface AssignmentContractorCompanyInfoViewModel {
    companyId?: string | undefined;
    companyKey?: string | undefined;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationViewModel;
    isDuplicated?: boolean;
    workerFile?: ResourceDownloadResponse;
}

export interface AssignmentCustomerViewModel {
    customerId?: string | undefined;
    customerKey?: string | undefined;
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    companyWebSite?: string | undefined;
    mspFee?: number | undefined;
    vmsFee?: number | undefined;
    breakInService?: BreakInServiceEnum;
}

export interface AssignmentEditAdminResponseModel {
    memberId?: string;
    memberCompanyId?: string;
    assignmentId?: string;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    assignmentStage?: AssignmentStageEnum;
    createdDate?: Date;
    updatedDate?: Date;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    assignmentDocument?: AssignmentPrimaryDocumentEditModel;
}

export interface AssignmentFinancialInfoEditModel {
    payType?: PayTypeEnum;
    payRate?: number | undefined;
    billRate?: number | undefined;
    dtPayRate?: number | undefined;
    dtBillRate?: number | undefined;
    profitRate?: number | undefined;
    overtime?: OvertimeEnum;
    overtimePayRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    mbpRate?: number | undefined;
}

export interface AssignmentFinancialInfoViewModel {
    payType?: PayTypeEnum;
    payRate?: number | undefined;
    billRate?: number | undefined;
    dtPayRate?: number | undefined;
    dtBillRate?: number | undefined;
    profitRate?: number | undefined;
    overtime?: OvertimeEnum;
    overtimePayRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    mbpRate?: number | undefined;
}

export interface AssignmentFinancialSchedulerEditModel {
    effectiveDate?: Date;
    financialInfoScheduler?: FinancialInfoSchedulerEditModel;
    multiRateSchedulers?: MultiRateSchedulerEditModel[] | undefined;
}

export interface AssignmentFinancialSchedulerViewModel {
    effectiveDate?: Date;
    isSyncedOnNetSuite?: boolean;
    financialInfoScheduler?: FinancialInfoSchedulerViewModel;
    multiRateSchedulers?: MultiRateSchedulerViewModel[] | undefined;
}

export interface AssignmentHistoryDetailsModel {
    oldData?: AssignmentHistoryResponse;
    newData?: AssignmentHistoryResponse;
}

export interface AssignmentHistoryResponse {
    w9FormFileName?: string | undefined;
    w9FormFileKey?: string | undefined;
    additionalInfo?: AssignmentAdminAdditionalInfoModel;
    assignmentStatus?: AssignmentStatusTypeEnum;
    stageStatus?: StageStatusEnum;
    status?: AssignmentStageEnum;
    priceAgreement?: BOUsersPriceAgreementRespModel;
    mspOrVmsOverviewInfo?: CustomerMspOrVmsOverviewDto;
    assignmentIsDraft?: boolean;
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    customerId?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    workerInfo?: AssignmentWorkerInfoEditModel;
    contractorCompanyInfo?: AssignmentContractorCompanyInfoEditModel;
    assignmentInfo?: AssignmentInfoEditModel;
    financialInfo?: AssignmentFinancialInfoEditModel;
    bestPrimaryContacts?: AssignmentContactPersonEditModel[] | undefined;
    bestBillingContacts?: AssignmentBillingContactEditModel[] | undefined;
    supervisorInfo?: AssignmentSupervisorInfoEditModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoViewModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoViewModel[] | undefined;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoViewModel;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation?: LocationModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation?: LocationModel;
    billingEmail?: string | undefined;
    splitPartnerInfo?: AssignmentSplitHistoryModel;
    partnerDraft?: AssignmentPartnerDraftModel;
    renewType?: RenewAssignmentEnum;
    parentAssignmentId?: string | undefined;
    isNeedCreateTemplate?: boolean;
    templateName?: string | undefined;
    multiRates?: AssignmentMultiRateEditModel[] | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
    termination?: AssignmentHistoryTerminationViewModel;
    assignmentRenewHistoryModel?: AssignmentRenewHistoryModel;
}

export interface AssignmentHistoryTerminationViewModel {
    terminationDate?: Date;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    eligibleForRehire?: boolean;
    details?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentInfoAdminResponseModel {
    assignmentAdminDocument?: AssignmentAdminDocumentModel;
    kronosSyncInfo?: AssignmentAdminKronosInfoModel;
    terminationKronosSyncInfo?: AssignmentAdminTerminationKronosInfoModel;
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    assignmentStage?: AssignmentStageEnum;
    stageStatus?: StageStatusEnum;
    createdDate?: Date;
    updatedDate?: Date;
    memberId?: string;
    memberKey?: string | undefined;
    memberCompanyName?: string | undefined;
    stages?: AssignmentStageModel[] | undefined;
    assignmentDocument?: AssignmentPrimaryDocumentViewModel;
    creator?: CreatorUserModel;
    questionnaireInfo?: AssignmentQuestionnaireInfoModel;
    contractorQuestionnaireInfo?: AssignmentQuestionnaireInfoModel;
    customerInfo?: AssignmentCustomerViewModel;
    partnerInfo?: AssignmentPartnerViewModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    renewStatus?: RenewStatusEnum;
    availableRenewOptions?: AvailableRenewOptionsEnum;
    isWorkerDuplicated?: boolean;
    childAssignmentId?: string | undefined;
    childAssignmentKey?: string | undefined;
    parentAssignmentKey?: string | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
    assignmentTeammates?: AssignmentTeammateSelectModel[] | undefined;
    companyId?: string;
}

export interface AssignmentInfoEditModel {
    jobTitle?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobDescription?: string | undefined;
    workFromHome?: WorkFromHomeEnum;
    preScreeningRequired?: boolean;
    preScreeningBilledTo?: PreScreeningBilledToEnum;
    jobCategory?: JobCategoryEnum;
    workCode?: string | undefined;
    employmentType?: EmploymentTypeEnum;
    anticipatedScheduleType?: AnticipatedScheduleTypeEnum;
    anticipatedSchedule?: AssignmentAnticipatedScheduleEditModel;
    specialInstructions?: string | undefined;
    customerPurchaseOrder?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentInfoViewModel {
    jobTitle?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    jobDescription?: string | undefined;
    workFromHome?: WorkFromHomeEnum;
    preScreeningRequired?: boolean;
    preScreeningBilledTo?: PreScreeningBilledToEnum;
    jobCategory?: JobCategoryEnum;
    workCode?: string | undefined;
    employmentType?: EmploymentTypeEnum;
    anticipatedScheduleType?: AnticipatedScheduleTypeEnum;
    anticipatedSchedule?: AssignmentAnticipatedScheduleViewModel;
    specialInstructions?: string | undefined;
    customerPurchaseOrder?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentLocationWithActualStateModel {
    isShowStatePriceAgreementWarning?: boolean;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    zipCode?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
}

export interface AssignmentMiniViewModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    createdDate?: Date;
}

export interface AssignmentMultiRateEditModel {
    id?: string | undefined;
    payType?: MultiRateEnum;
    specialInstructions?: string | undefined;
    memberBilledIndicator?: boolean;
    payCodeId?: string;
    payRate?: number | undefined;
    billRate?: number | undefined;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
}

export interface AssignmentMultiRateViewModel {
    id?: string | undefined;
    payType?: MultiRateEnum;
    payRate?: number | undefined;
    billRate?: number | undefined;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
    specialInstructions?: string | undefined;
    memberBilledIndicator?: boolean;
    payCodeId?: string;
}

export interface AssignmentPartnerDraftModel {
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface AssignmentPartnerViewModel {
    partnerId?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    partnerStatus?: PartnerStatusEnum;
    invitedCompanyId?: string | undefined;
}

export interface AssignmentPrimaryDocumentEditModel {
    assignmentIsDraft?: boolean;
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    customerId?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    assignmentTeammates?: AssignmentTeammatesEditModel[] | undefined;
    workerInfo?: AssignmentWorkerInfoEditModel;
    contractorCompanyInfo?: AssignmentContractorCompanyInfoEditModel;
    assignmentInfo?: AssignmentInfoEditModel;
    financialInfo?: AssignmentFinancialInfoEditModel;
    bestPrimaryContacts?: AssignmentContactPersonEditModel[] | undefined;
    bestBillingContacts?: AssignmentBillingContactEditModel[] | undefined;
    supervisorInfo?: AssignmentSupervisorInfoEditModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoEditModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoEditModel[] | undefined;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoEditModel;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation?: LocationModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation?: LocationModel;
    billingEmail?: string | undefined;
    splitInfo?: AssignmentSplitInfoEditModel;
    partnerDraft?: AssignmentPartnerDraftModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    isNeedCreateTemplate?: boolean;
    templateName?: string | undefined;
    multiRates?: AssignmentMultiRateEditModel[] | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
}

export interface AssignmentPrimaryDocumentViewModel {
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    customerId?: string | undefined;
    workerInfo?: AssignmentWorkerInfoViewModel;
    companyInfo?: AssignmentContractorCompanyInfoViewModel;
    assignmentInfo: AssignmentInfoViewModel;
    financialInfo: AssignmentFinancialInfoViewModel;
    bestPrimaryContacts: AssignmentContactPersonViewModel[];
    bestBillingContacts: AssignmentBillingContactViewModel[];
    multiRates: AssignmentMultiRateViewModel[];
    financialScheduler?: AssignmentFinancialSchedulerViewModel;
    supervisorInfo: AssignmentSupervisorInfoViewModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoViewModel;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoViewModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoViewModel[] | undefined;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation: LocationViewModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation: LocationViewModel;
    billingEmail?: string | undefined;
    splitInfo?: AssignmentSplitInfoViewModel;
}

export interface AssignmentQuestionnaireInfoModel {
    ongoingTrainingRequired?: QuestionnaireModel;
    customerControl?: QuestionnaireModel;
    clockInOrOutDictated?: QuestionnaireModel;
    supervisionOfWorker?: QuestionnaireModel;
    suppliesProvision?: QuestionnaireModel;
    businessExpensesReimbursed?: QuestionnaireModel;
    specializedSkillsetEmployeeAvailbility?: QuestionnaireModel;
    servicesAreKeyAspectOfBM?: QuestionnaireModel;
    workerPerformedSimilarServices?: QuestionnaireModel;
    servicesAdvertisedByWorker?: QuestionnaireModel;
}

export enum AssignmentRateTypeEnum {
    Percent = 1,
    Money = 2,
}

export interface AssignmentRenewHistoryModel {
    assignmentId?: string;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    action?: RenewActionEnum;
}

export interface AssignmentSplitHistoryModel {
    splitType?: SplitTypeEnum;
    partnerId?: string | undefined;
    splitPercent?: number | undefined;
    splitAmount?: number | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    country?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface AssignmentSplitInfoEditModel {
    splitType?: SplitTypeEnum;
    partnerId?: string | undefined;
    splitPercent?: number | undefined;
    splitAmount?: number | undefined;
}

export interface AssignmentSplitInfoViewModel {
    splitType?: SplitTypeEnum;
    partnerId?: string | undefined;
    splitPercent?: number | undefined;
    splitAmount?: number | undefined;
}

export enum AssignmentStageEnum {
    Pending = 1,
    EECandidateSentOnboarding = 21,
    EERatesAndCustomerReviewed = 41,
    EECandidateCompletedOnboarding = 61,
    EEOnboardingPackageVerified = 81,
    EEPreScreeningValidating = 101,
    EEPreScreeningCompleted = 121,
    EETimesheetAccountCreated = 141,
    EEAssignmentConfirmed = 161,
    ICMemberQuestionnaire = 179,
    ICMemberQuestionnaireComplete = 181,
    ICRatesAndCustomerReviewed = 201,
    ICContractorQuestionnaire = 219,
    ICContractorQuestionnaireComplete = 221,
    ICContractorChecklistVerified = 241,
    ICContractorSentPackage = 261,
    ICAcquiringApplicableInsurances = 281,
    ICPreScreeningValidating = 301,
    ICPreScreeningCompleted = 321,
    ICVendorProfileFinalized = 341,
    ICFinalAgreementUploaded = 361,
    SubcontractorContractorSentPackage = 381,
    SubcontractorRatesAndCustomerReviewed = 401,
    SubcontractorWorkAuthorizationVerified = 421,
    SubcontractorPreScreeningValidating = 441,
    SubcontractorPreScreeningCompleted = 461,
    SubcontractorVendorProfileFinalized = 481,
    SubcontractorFinalAgreementUploaded = 501,
    Renewed = 601,
    Rehired = 621,
}

export enum AssignmentStageFilterEnum {
    All = 0,
    Pending = 1,
    CandidateSentOnboarding = 2,
    MemberQuestionnaireComplete = 3,
    RatesAndCustomerReviewed = 4,
    CandidateCompletedOnboarding = 5,
    OnboardingPackageVerified = 6,
    ContractorQuestionnaireComplete = 7,
    ContractorChecklistVerified = 8,
    ContractorSentPackage = 9,
    AcquiringApplicableInsurances = 10,
    WorkAuthorizationVerified = 11,
    PreScreeningValidating = 12,
    PreScreeningCompleted = 13,
    TimesheetAccountCreated = 14,
    AssignmentConfirmed = 15,
    VendorProfileFinalized = 16,
    FinalAgreementUploaded = 17,
}

export interface AssignmentStageModel {
    stage?: AssignmentStageEnum;
    stageStatus?: StageStatusEnum;
    additionalInfoRequest?: string | undefined;
    additionalInfoReply?: string | undefined;
    showPulsatingIndicator?: boolean;
}

export enum AssignmentStatusTypeEnum {
    Draft = 0,
    Request = 1,
    Active = 2,
    Completed = 3,
    Cancelled = 4,
}

export interface AssignmentSummaryWorkerModel {
    workerId?: string | undefined;
    workerKey?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    taxId?: number | undefined;
    workerFileKey?: string | undefined;
}

export interface AssignmentSupervisorInfoEditModel {
    supervisorId?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentSupervisorInfoViewModel {
    id?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTeammateSelectModel {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    rate?: number | undefined;
    rateType?: AssignmentRateTypeEnum;
    pendingTeammateEmail?: string | undefined;
    externalFullName?: string | undefined;
    teammateType?: AssignmentTeammateTypeEnum;
}

export enum AssignmentTeammateTypeEnum {
    Teammate = 0,
    PendingTeammate = 1,
    ExternalRecruiter = 2,
}

export interface AssignmentTeammatesEditModel {
    userId?: string | undefined;
    pendingTeammateEmail?: string | undefined;
    externalFullName?: string | undefined;
    teammateType?: AssignmentTeammateTypeEnum;
    rate?: number | undefined;
    rateType?: AssignmentRateTypeEnum;
}

export interface AssignmentTerminationCreateUpdateApiModel {
    assignmentId?: string;
    terminationDate?: Date;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    eligibleForRehire?: boolean;
    details?: string | undefined;
    attachments?: NamedAttachmentModel[] | undefined;
}

export interface AssignmentTerminationModel {
    assignmentId?: string;
    terminationDate?: Date;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    eligibleForRehire?: boolean;
    details?: string | undefined;
    readonly attachments?: NamedAttachmentModel[] | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    readonly isApplied?: boolean;
}

export enum AssignmentTerminationReasonTypeEnum {
    Converted = 1,
    AssignmentCancelled = 2,
    Resigned = 3,
    AttendanceIssue = 4,
    PerformanceIssue = 5,
    MisconductIssue = 6,
    AssignmentComplete = 7,
}

export enum AssignmentTerminationToKronosEnum {
    Ready = 0,
    ImmediatelySync = 1,
    SchedulerSync = 2,
    InProgress = 3,
    EECalifornianSync = 4,
    Success = 5,
    Fail = 10,
}

export interface AssignmentTimesheetApproverInfoEditModel {
    timesheetApproverId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTimesheetApproverInfoViewModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTimesheetBackupApproverInfoEditModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTimesheetBackupApproverInfoViewModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface AssignmentTitleInfoModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    assignmentStatus?: AssignmentStatusTypeEnum;
    assignmentStage?: AssignmentStageEnum;
    assignmentType?: AssignmentTypeEnum;
    assignmentCategory?: AssignmentCategoryEnum;
    terminationReason?: AssignmentTerminationReasonTypeEnum;
    createdDate?: Date;
    updatedDate?: Date;
    workerInfo?: AssignmentSummaryWorkerModel;
    memberId?: string;
    memberKey?: string | undefined;
    memberCompanyName?: string | undefined;
    jobTitle?: string | undefined;
    jobStartDate?: Date | undefined;
    jobEndDate?: Date | undefined;
    workLocation?: LocationViewModel;
    billingLocation?: LocationViewModel;
    customerInfo?: AssignmentCustomerViewModel;
    renewType?: RenewAssignmentEnum;
    parentAssignmentId?: string | undefined;
    parentAssignmentKey?: string | undefined;
    renewStatus?: RenewStatusEnum;
    renewKind?: RenewKindEnum;
    childAssignmentId?: string | undefined;
}

export interface AssignmentToKronosInfoExistViewModel {
    import1Exist?: boolean;
    import2Exist?: boolean;
    import3Exist?: boolean;
    import4Exist?: boolean;
    terminationExist?: boolean;
    terminationDetailsExist?: boolean;
    multiRatesExist?: boolean;
}

export enum AssignmentTypeEnum {
    EEAssignment = 1,
    ICAssignment = 2,
    SCAssignment = 3,
}

export interface AssignmentWorkerInfoEditModel {
    workerId?: string | undefined;
    workerInfo?: BaseEmployeeModel;
    location?: LocationModel;
    workerType?: WorkerTypeEnum;
    workerFile?: ResourceDownloadResponse;
}

export interface AssignmentWorkerInfoViewModel {
    workerId?: string | undefined;
    workerInfo?: BaseEmployeeModel;
    workerKey?: string | undefined;
    workerType?: WorkerTypeEnum;
    workerFile?: ResourceDownloadResponse;
    location?: AssignmentLocationWithActualStateModel;
    isDuplicated?: boolean;
}

export interface AssignmentsTypePayCodes {
    assignmentType?: AssignmentTypeEnum;
    payCodeId?: string[] | undefined;
}

export enum AvailableRenewOptionsEnum {
    None = 0,
    Renew = 1,
    Rehire = 2,
}

export interface BOAccountViewModel {
    userId?: string;
    memberKey?: string | undefined;
    logoFileKey?: string | undefined;
    website?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    companyId?: string;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    businessEmail?: string | undefined;
    isAssignment?: boolean;
    ownerFirstName?: string | undefined;
    ownerLastName?: string | undefined;
    ownerEmail?: string | undefined;
    bestContactFirstName?: string | undefined;
    bestContactLastName?: string | undefined;
    bestContactEmail?: string | undefined;
    contactPhoneNumber?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    countryName?: string | undefined;
    countryId?: number;
    internationalCityId?: number | undefined;
    status?: BOUserStatusEnum;
    stageStatus?: StageStatusEnum;
    stages?: any | undefined;
    boUserType?: BOUserTypeEnum;
    profileType?: ProfileTypeEnum;
    createdDate?: Date;
    placementStates?: StateEntity[] | undefined;
    industries?: IndustryEntity[] | undefined;
    outreach?: OutreachModel;
    isConfirmation?: boolean;
}

export interface BOAdminViewModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    lastLogin?: Date | undefined;
}

export interface BOAdminViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: BOAdminViewModel[] | undefined;
}

export interface BOMemberShortViewModel {
    companyId?: string;
    companyName?: string | undefined;
}

export interface BOUserListResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: BOAccountViewModel[] | undefined;
}

export interface BOUserNotificationModel {
    userId?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export enum BOUserRequestStatusEnum {
    All = 0,
    MembersRequests = 1,
    Members = 2,
}

export enum BOUserStatusEnum {
    All = 0,
    Pending = 1,
    Reviewed = 21,
    OutreachConducted = 41,
    PriceAgreementChanged = 59,
    PriceAgreementSent = 61,
    PriceAgreementSigned = 81,
    Completed = 101,
}

export enum BOUserTypeEnum {
    Company = 1,
    SelfEmployed = 2,
    International = 3,
}

export enum BOUserTypeFilterEnum {
    All = 0,
    Company = 1,
    SelfEmployed = 2,
    International = 3,
}

export interface BOUsersApproveStepModel {
    userId?: string;
    currentStage?: BOUserStatusEnum;
    currentStageStatus?: StageStatusEnum;
    message?: string | undefined;
}

export enum BOUsersBankingInfoTypeEnum {
    Default = 0,
    DirectDeposit = 1,
    MailMyChecks = 2,
    International = 3,
}

export interface BOUsersPriceAgreementModel {
    companyId?: string;
    w2InfoList?: PriceAgreementEEInfoModel[] | undefined;
    icPrice?: number;
    fundingType?: FundingTypeEnum;
    supportingFiles?: ExtendedNamedAttachmentModel[] | undefined;
}

export interface BOUsersPriceAgreementRespModel {
    companyId?: string;
    w2InfoList?: PriceAgreementW2InfoResponseModel[] | undefined;
    icPrice?: number;
    canBeConfirmed?: boolean;
    hasChangeRequest?: boolean;
    confirmationSignature?: string | undefined;
    confirmationDate?: Date | undefined;
    isConfirmation?: boolean | undefined;
    fundingType?: FundingTypeEnum;
    supportingFiles?: ExtendedNamedAttachmentModel[] | undefined;
}

export interface BOUsersStageModel {
    stage?: BOUserStatusEnum;
    stageStatus?: StageStatusEnum;
    additionalInfoRequest?: string | undefined;
    additionalInfoReply?: string | undefined;
    showPulsatingIndicator?: boolean;
}

export enum BankingInfoAccountTypeEnum {
    Default = 0,
    Savings = 1,
    Checking = 2,
}

export interface BankingInfoDirectDepositModel {
    bankName?: string | undefined;
    holderName?: string | undefined;
    accountNumber?: string | undefined;
    routingNumber?: string | undefined;
    accountType?: BankingInfoAccountTypeEnum;
    ddEmailAddress?: string | undefined;
    isConfirmation?: boolean;
}

export interface BankingInfoInternationalModel {
    accountHolderName?: string | undefined;
    internationalBankName?: string | undefined;
    internationalAccountNumber?: string | undefined;
    swiftCode?: string | undefined;
    internationalRoutingCode?: string | undefined;
    confirmation1?: boolean;
    confirmation2?: boolean;
}

export interface BankingInfoMailMyChecksRequestModel {
    payableTo?: string | undefined;
    stateId?: number;
    city?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    isConfirmation?: boolean;
}

export interface BankingInfoMailMyChecksResponseModel {
    payableTo?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    isConfirmation?: boolean;
}

export interface BankingInformationRequestModel {
    directDepositDetail?: BankingInfoDirectDepositModel;
    mailMyChecksDetail?: BankingInfoMailMyChecksRequestModel;
    internationalDetail?: BankingInfoInternationalModel;
    bankInfoFileKey?: string | undefined;
    bankingInformationType?: BOUsersBankingInfoTypeEnum;
}

export interface BankingInformationResponseModel {
    directDepositDetail?: BankingInfoDirectDepositModel;
    mailMyChecksDetail?: BankingInfoMailMyChecksResponseModel;
    internationalDetail?: BankingInfoInternationalModel;
    bankingInformationType?: BOUsersBankingInfoTypeEnum;
    bankInfoFileKey?: string | undefined;
    bankInfoFileName?: string | undefined;
}

export interface BaseAddressModel {
    address: string;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zip: string;
}

export interface BaseEmployeeModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    taxId?: number | undefined;
    workerFileKey?: string | undefined;
}

export interface BillingContactModel {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface BillingInfoResponseModel {
    billingContacts?: BillingContactModel[] | undefined;
    location?: BaseAddressModel;
    isBillingSameAsMainAddress?: boolean;
}

export interface BillingInformationModel {
    billingContacts?: BillingContactModel[] | undefined;
    location?: LocationModel;
    isBillingSameAsMainAddress?: boolean;
}

export enum BreakInServiceEnum {
    Days0 = 0,
    Days30 = 30,
    Days60 = 60,
    Days90 = 90,
    Days120 = 120,
    Days180 = 180,
}

export interface BulkAssignmentImportResponse {
    result?: CreateAssignmentResponse;
    errors?: ValidationDetailsModel[] | undefined;
    validationFailures?: ValidationFailure[] | undefined;
    readonly success?: boolean;
}

export interface BulkCustomerImportResponse {
    companyName?: string | undefined;
    result?: CreateCustomerResponse;
    errors?: ValidationDetailsModel[] | undefined;
    validationFailures?: ValidationFailure[] | undefined;
    readonly success?: boolean;
}

export interface BusinessInfoModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    location?: LocationModel;
    assignmentLocations?: number[] | undefined;
    industry?: string[] | undefined;
    assignment?: boolean;
    businessEmail?: string | undefined;
}

export interface BusinessInfoResponseModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    location?: BaseAddressModel;
    assignmentLocations?: StateEntity[] | undefined;
    industries?: IndustryEntity[] | undefined;
    outreach?: OutreachModel;
    priceAgreement?: BOUsersPriceAgreementRespModel;
    entityInformation?: EntityInformationResponseModel;
    assignment?: boolean;
    businessEmail?: string | undefined;
}

export enum CommissionTypeEnum {
    SelfFunded = 1,
    PaidWhenPaid = 2,
    AdvancedCommission = 3,
}

export interface CompanyBankingInformationRequestModel {
    companyId?: string;
    bankingInformation?: BankingInformationRequestModel;
}

export interface CompanyRequestModel {
    companyId?: string;
    website?: string | undefined;
    ownerInfo?: PersonInfoModel;
    bestContact?: PersonInfoModel;
    businessInfo?: BusinessInfoModel;
}

export interface CompanySelectModel {
    companyId?: string;
    companyName?: string | undefined;
    memberKey?: string | undefined;
}

export interface ContactPersonModel {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    title?: string | undefined;
}

export interface ContractorCompanyDetailAdminViewModel {
    duplicates?: ContractorCompanyItemViewModel[] | undefined;
    referredMembers?: ContractorCompanyRelatedMemberViewModel[] | undefined;
    referredAssignments?: ContractorCompanyRelatedAssignmentViewModel[] | undefined;
    id?: string;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationViewModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    currentRevision?: number;
    companyKey?: string | undefined;
    isDuplicated?: boolean;
    createdBy?: CreatorUserModel;
    assignmentsCount?: number;
    memberCompanyFirstName?: string | undefined;
    memberCompanyLastName?: string | undefined;
    memberKey?: string | undefined;
}

export interface ContractorCompanyItemViewModel {
    id?: string;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationViewModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    currentRevision?: number;
    companyKey?: string | undefined;
    isDuplicated?: boolean;
    createdBy?: string;
    assignmentsCount?: number;
    memberCompanyFirstName?: string | undefined;
    memberCompanyLastName?: string | undefined;
    memberKey?: string | undefined;
}

export interface ContractorCompanyItemViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: ContractorCompanyItemViewModel[] | undefined;
}

export interface ContractorCompanyModel {
    id?: string;
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    contractorCompanyType?: ContractorCompanyTypeEnum;
    location?: LocationModel;
    companyKey?: string | undefined;
    isDuplicated?: boolean;
    createdBy?: string;
}

export interface ContractorCompanyRelatedAssignmentViewModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface ContractorCompanyRelatedMemberViewModel {
    id?: string;
    memberKey?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export enum ContractorCompanyTypeEnum {
    IC = 2,
    ParentSC = 3,
}

export interface CreateAssignmentCommentRequestModel {
    assignmentId?: string;
    text?: string | undefined;
}

export interface CreateAssignmentResponse {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface CreateCustomerCommentRequestModel {
    customerId?: string;
    text?: string | undefined;
}

export interface CreateCustomerGeneralInfo {
    companyInfo: CustomerCompanyInfoModel;
    primaryContacts: ContactPersonModel[];
}

export interface CreateCustomerGroupViewModel {
    name?: string | undefined;
}

export interface CreateCustomerRequest {
    generalInfo: CreateCustomerGeneralInfo;
    additionalInfo: AdditionalInfoModel;
    agreementDetailsInfo: ServiceAgreementInfoModel;
    billingInfo: BillingInformationModel;
    customerGroupName?: string | undefined;
    customerGroupId?: string | undefined;
}

export interface CreateCustomerResponse {
    customerId?: string;
    customerKey?: string | undefined;
}

export interface CreateMemberCommentRequestModel {
    memberId?: string;
    text?: string | undefined;
}

export interface CreateWorkerModel {
    workerInfo?: BaseEmployeeModel;
    location?: LocationModel;
    workerType?: WorkerTypeEnum;
}

export interface CreatorUserModel {
    id?: string;
    fullName?: string | undefined;
}

export interface CustomerAdditionalInfo3Model {
    assignmentRequirements?: CustomerAssignmentRequirementsModel;
    specialAssignmentRequirements?: CustomerSpecialAssignmentRequirementsModel;
}

export interface CustomerAdditionalInfoModel {
    generalContractInformation?: CustomerGeneralContractInformation;
    financialInformation?: CustomerFinancialInformationModel;
    additionalInfo3?: CustomerAdditionalInfo3Model;
}

export interface CustomerAdditionalInfoResponseModel {
    customerId?: string;
    customerCompanyName?: string | undefined;
    generalContractInformation?: CustomerGeneralContractInformation;
    financialInformation?: CustomerFinancialInformationModel;
    additionalInfo3?: CustomerAdditionalInfo3Model;
    customerKey?: string | undefined;
}

export interface CustomerApproveStepModel {
    customerId?: string;
    currentStage?: CustomerStatusEnum;
    currentStageStatus?: StageStatusEnum;
    message?: string | undefined;
}

export interface CustomerAssignmentRequirementsModel {
    isIndependentContractors?: boolean | undefined;
    isPreScreeningRequired?: boolean | undefined;
    preScreeningBilledTo?: CustomerPreScreeningProviderEnum;
    preScreening?: string | undefined;
    isOnboardingDocumentationRequired?: boolean | undefined;
    onboardingDocumentationFileKeys?: string[] | undefined;
    onboardingDocumentationFileNames?: string[] | undefined;
    designatedPreScreeningProvider?: boolean | undefined;
    specialInstructions?: string | undefined;
    terminationInstructions?: string | undefined;
}

export interface CustomerCommentViewModel {
    id?: string;
    customerId?: string;
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    updatedById?: string | undefined;
    updatedByFirstName?: string | undefined;
    updatedByLastName?: string | undefined;
    text?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
}

export interface CustomerCommentsPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CustomerCommentViewModel[] | undefined;
}

export enum CustomerCompaniesFilterEnum {
    Member = 1,
    Customer = 2,
}

export interface CustomerCompanyInfoModel {
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    companyWebSite?: string | undefined;
    companyEmail?: string | undefined;
    companyPhoneNumber?: string | undefined;
    location: LocationModel;
}

export enum CustomerCostingMethodTypeEnum {
    Blended = 0,
    CostPlus = 1,
}

export enum CustomerDocumentTypeEnum {
    CertificateOfInsurance = 0,
    Agreement = 1,
    SowTemplate = 2,
    TempToPermConversion = 3,
    OnboardingDocumentation = 4,
    PurchaseOrder = 5,
}

export interface CustomerEditResponse {
    customerId: string;
    status?: CustomerStatusEnum;
    memberId?: string;
    memberCompanyId?: string;
    createdDate?: Date;
    updatedDate?: Date;
    customerGroupId?: string | undefined;
    customerGroupName?: string | undefined;
    customerDocument: CreateCustomerRequest;
}

export interface CustomerFinancialInformationModel {
    financialOverview?: CustomerFinancialOverviewModel;
    rateOverview?: CustomerRateOverviewModel;
    mspOrVmsOverview?: CustomerMspOrVmsOverviewModel;
}

export interface CustomerFinancialOverviewModel {
    creditCheckScore?: string | undefined;
    commissionTypeApproval?: CommissionTypeEnum;
    advancedCommission?: string | undefined;
    paidWhenPaid?: string | undefined;
    selfFunded?: string | undefined;
    addedNotes?: string | undefined;
    paymentTerm?: PaymentTermEnum;
    customerCostingMethodType?: CustomerCostingMethodTypeEnum;
}

export interface CustomerGeneralContractInformation {
    insuranceRequirements?: CustomerInsuranceRequirementsModel;
}

export interface CustomerGroup {
    id?: string;
    userId?: string;
    name?: string | undefined;
    createdDate?: Date;
}

export interface CustomerHistoryDetailsModel {
    oldData?: FullCustomerInfoResponseModel;
    newData?: FullCustomerInfoResponseModel;
}

export interface CustomerInfoCompanyInfoModel {
    companyName: string;
    additionalInvoiceName?: string | undefined;
    companyWebSite?: string | undefined;
    companyPhoneNumber?: string | undefined;
    companyEmail?: string | undefined;
    location: BaseAddressModel;
}

export interface CustomerInfoResponseModel {
    customerId?: string;
    customerKey?: string | undefined;
    userId?: string;
    companyId?: string;
    status?: CustomerStatusEnum;
    stageStatus?: StageStatusEnum;
    stages?: CustomerStageModel[] | undefined;
    recruiterCompanyName?: string | undefined;
    recruiterCompanyId?: string;
    recruiterCompanyKey?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    customerInfo: CustomerInfoCompanyInfoModel;
    primaryContacts: ContactPersonModel[];
    billingInfo: BillingInfoResponseModel;
    additionalInfo: AdditionalInfoModel;
    agreementDetails: CustomerInfoServiceAgreementModel;
    isAdminAdditionalInfoExists?: boolean;
    creator?: CreatorUserModel;
    customerGroupId?: string | undefined;
    customerGroupName?: string | undefined;
}

export interface CustomerInfoServiceAgreementModel {
    agreementDetailsType: ServiceAgreementTypeEnum;
    agreementAttachments: ExtendedNamedAttachmentModel[];
}

export interface CustomerInsuranceRequirementsModel {
    certificateOfInsuranceSpecifications?: string | undefined;
    submittedTo?: string | undefined;
    certificateOfInsuranceCreatedFileKey?: string | undefined;
    certificateOfInsuranceCreatedFileName?: string | undefined;
    isCreditCheckVerified?: boolean | undefined;
    sowRequired?: boolean | undefined;
    sowTemplateFileKey?: string | undefined;
    sowTemplateFileName?: string | undefined;
    sowSpecialInstructions?: string | undefined;
}

export interface CustomerMiniViewModel {
    customerId?: string;
    customerKey?: string | undefined;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    createdDate?: Date;
}

export interface CustomerMspOrVmsOverviewDto {
    mspFee?: string | undefined;
    vmsFee?: number | undefined;
    invoicingInformation?: string | undefined;
    specialInvoicingInstructions?: string | undefined;
    invoicingCycle?: InvoicingCycleEnum;
    payrollCycle?: PayPeriodEnum;
    isThereThirdPartyWorkforce?: boolean | undefined;
    url?: string | undefined;
    credentials?: string | undefined;
    mspOrVmsProviderName?: string | undefined;
    purchaseOrder?: boolean | undefined;
    purchaseOrderFileKey?: string | undefined;
    purchaseOrderInstructions?: string | undefined;
}

export interface CustomerMspOrVmsOverviewModel {
    mspFee?: number | undefined;
    vmsFee?: number | undefined;
    invoicingInformation?: string | undefined;
    specialInvoicingInstructions?: string | undefined;
    invoicingCycle?: InvoicingCycleEnum;
    payrollCycle?: PayPeriodEnum;
    isThereThirdPartyWorkforce?: boolean | undefined;
    url?: string | undefined;
    credentials?: string | undefined;
    mspOrVmsProviderName?: string | undefined;
    purchaseOrder?: boolean | undefined;
    purchaseOrderFileKey?: string | undefined;
    purchaseOrderFileName?: string | undefined;
    purchaseOrderInstructions?: string | undefined;
}

export interface CustomerPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CustomerInfoResponseModel[] | undefined;
}

export enum CustomerPreScreeningProviderEnum {
    Member = 1,
    MBP = 2,
    Customer = 3,
}

export interface CustomerRateOverviewModel {
    fixedMarkupRate?: string | undefined;
    otRateMultiplier?: string | undefined;
    tempToPermConversionFileKey?: string | undefined;
    tempToPermConversionFileName?: string | undefined;
    dtBillRateMultiplier?: number | undefined;
}

export interface CustomerResponseModel {
    customerId?: string;
    primaryContacts?: ContactPersonModel[] | undefined;
    billingContacts?: BillingContactModel[] | undefined;
    companyId?: string;
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    customerCompanyId?: string;
    customerCompanyName?: string | undefined;
    customerAdditionalInvoiceName?: string | undefined;
    state?: string | undefined;
    stateId?: number;
    city?: string | undefined;
    internationalCity?: string | undefined;
    internationalState?: string | undefined;
    countryName?: string | undefined;
    countryId?: number | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    status?: CustomerStatusEnum;
    createdDate?: Date;
    isOtherPrimaryContactAvailable?: boolean;
    isOtherBillingContactAvailable?: boolean;
    billingAPEmail?: string | undefined;
    billingLocation?: BaseAddressModel;
    mspOrVmsOverviewInfo?: CustomerMspOrVmsOverviewDto;
    breakInService?: BreakInServiceEnum;
}

export interface CustomerSearchResponseModel {
    customerId?: string;
    companyName?: string | undefined;
    additionalInvoiceName?: string | undefined;
    customerKey?: string | undefined;
}

export enum CustomerSizeEnum {
    From0To20 = 0,
    From21To80 = 21,
    From81To200 = 81,
    From201To800 = 201,
    From801To1500 = 801,
    From1501Plus = 1501,
}

export interface CustomerSpecialAssignmentRequirementsModel {
    guaranteedWorkPerformance?: string | undefined;
    tempToPermConversion?: string | undefined;
    addedNotes?: string | undefined;
    timeEntry?: string | undefined;
    breakInService?: BreakInServiceEnum;
}

export interface CustomerStageModel {
    stage?: CustomerStatusEnum;
    stageStatus?: StageStatusEnum;
    additionalInfoRequest?: string | undefined;
    additionalInfoReply?: string | undefined;
    showPulsatingIndicator?: boolean;
}

export enum CustomerStatusEnum {
    Requested = 1,
    NewCustomerSetupStarted = 21,
    CreditCheckVerified = 41,
    UnderLegalReview = 61,
    AcquiringCertificateOfInsurance = 81,
    ApprovedByFinance = 101,
    ApprovedByLegal = 121,
    CounterSignaturesCompleted = 141,
    StaffOnboardingPackagesCreated = 161,
    FinalAgreementUploaded = 181,
    NewCustomerSetupComplete = 201,
    Draft = -1,
}

export enum CustomerStatusFilterEnum {
    All = 0,
    Requested = 1,
    InProgress = 2,
    NewCustomerSetupStarted = 21,
    CreditCheckVerified = 41,
    UnderLegalReview = 61,
    AcquiringCertificateOfInsurance = 81,
    ApprovedByFinance = 101,
    ApprovedByLegal = 121,
    CounterSignaturesCompleted = 141,
    StaffOnboardingPackagesCreated = 161,
    FinalAgreementUploaded = 181,
    NewCustomerSetupComplete = 201,
    Draft = -1,
}

export interface DashboardAssignmentResponseModel {
    totalCount?: number;
    details?: AssignmentMiniViewModel[] | undefined;
}

export interface DashboardCustomerResponseModel {
    totalCount?: number;
    details?: CustomerMiniViewModel[] | undefined;
}

export interface DateTimeModel {
    date?: Date | undefined;
    time?: string | undefined;
    timeZone?: string | undefined;
}

export enum DurationTypeEnum {
    Week = 1,
    Month = 2,
    Year = 3,
}

export interface EditAssignmentCommentRequestModel {
    id?: string;
    text?: string | undefined;
}

export interface EditCustomerCommentRequestModel {
    id?: string;
    text?: string | undefined;
}

export interface EditMemberCommentRequestModel {
    id?: string;
    text?: string | undefined;
}

export enum EmploymentTypeEnum {
    FullTime = 1,
    PartTime = 2,
}

export enum EntityInfoNumberTypeEnum {
    Ssn = 1,
    Ein = 2,
}

export interface EntityInformationRequestModel {
    companyId?: string;
    name?: string | undefined;
    number?: string | undefined;
    numberType?: EntityInfoNumberTypeEnum;
    entityInfoFileKey?: string | undefined;
    countryId?: number | undefined;
}

export interface EntityInformationResponseModel {
    name?: string | undefined;
    number?: string | undefined;
    numberType?: EntityInfoNumberTypeEnum;
    entityInfoFileKey?: string | undefined;
    entityInfoFileName?: string | undefined;
    countryId?: number | undefined;
    countryName?: string | undefined;
}

export interface ExtendedNamedAttachmentModel {
    createdDate?: Date | undefined;
    fileKey?: string | undefined;
    fileName?: string | undefined;
}

export enum FileTypeEnum {
    CustomerCreationTemplate = 1,
    AssignmentCreationTemplate = 2,
}

export interface FinancialInfoSchedulerEditModel {
    payType?: PayTypeEnum;
    overtime?: OvertimeEnum;
    mbpRate?: number | undefined;
    payRate?: number | undefined;
    billRate?: number | undefined;
    dtBillRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    overtimePayRate?: number | undefined;
    profitRate?: number | undefined;
}

export interface FinancialInfoSchedulerViewModel {
    payRate?: number | undefined;
    mbpRate?: number | undefined;
    billRate?: number | undefined;
    profitRate?: number | undefined;
    dtBillRate?: number | undefined;
    overtimeBillRate?: number | undefined;
    payType?: PayTypeEnum;
    overtimePayRate?: number | undefined;
    overtime?: OvertimeEnum;
}

export interface FullBOUserResponseModel {
    companyId?: string;
    userId?: string;
    memberKey?: string | undefined;
    memberLogoUrl?: string | undefined;
    website?: string | undefined;
    registeredEmail?: string | undefined;
    registeredFirstName?: string | undefined;
    registeredLastName?: string | undefined;
    status?: BOUserStatusEnum;
    stageStatus?: StageStatusEnum;
    stages?: BOUsersStageModel[] | undefined;
    boUserType?: BOUserTypeEnum;
    profileType?: ProfileTypeEnum;
    createdDate?: Date;
    ownerInfo?: PersonInfoModel;
    bestContact?: PersonInfoModel;
    businessInfo?: BusinessInfoResponseModel;
    bankingInformation?: BankingInformationResponseModel;
    corporateInfo?: ProfileCorporateInfoModel;
}

export interface FullCustomerInfoResponseModel {
    additionalInfo?: CustomerAdditionalInfoModel;
    generalInfo?: CreateCustomerRequest;
    status?: CustomerStatusEnum;
    stageStatus?: StageStatusEnum;
}

export enum FundingTypeEnum {
    Funded = 0,
    SelfFunded = 1,
    Both = 2,
}

export interface GetTotalNumbersResponse {
    /** Displays the number of members in the application that finished the initial profile setup. */
    readonly members: number;
    /** Displays the number of members with Recruiter type in the application that finished the initial profile setup. */
    readonly recruiterMembers: number;
    /** Displays the number of members with Corporate type in the application that finished the initial profile setup. */
    readonly corporateMembers: number;
    /** Displays the number of approved customers in the application. */
    readonly customers: number;
    /** Displays the number of approved assignments in the application. */
    readonly assignments: number;
}

export interface HistoryResponseModel {
    id?: string;
    userId?: string;
    updatedBy?: string | undefined;
    details?: any | undefined;
    createdDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    type?: HistoryTypeEnum;
}

export interface HistoryResponseModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: HistoryResponseModel[] | undefined;
}

export enum HistoryTypeEnum {
    Details = 1,
    Stage = 2,
    Scheduler = 3,
    Integration = 4,
    Termination = 5,
    CustomerAgreement = 6,
    RescindingTermination = 7,
    RenewalRehire = 8,
}

export interface HomepageStatisticsResponse {
    independentRecruiterCount?: number;
    independentConsultantCount?: number;
    corporateTAEntityCount?: number;
}

export interface ImportAdminCustomerListViewModel {
    memberId: string;
    models: CreateCustomerRequest[];
}

export interface IndustryEntity {
    id?: number;
    name?: string | undefined;
}

export interface InternalionalLocationModel {
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    countryId?: number | undefined;
    zipCode?: string | undefined;
    stateId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
}

export interface InternationalBusinessInfoModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    location?: InternalionalLocationModel;
    assignmentLocations?: number[] | undefined;
    industry?: string[] | undefined;
    assignment?: boolean;
    businessEmail?: string | undefined;
}

export interface InternationalRequestModel {
    companyId?: string;
    website?: string | undefined;
    ownerInfo?: PersonInfoModel;
    bestContact?: PersonInfoModel;
    businessInfo?: InternationalBusinessInfoModel;
}

export enum InvoicingCycleEnum {
    Weekly = 1,
    BiWeekly = 2,
    Monthly = 3,
    SemiMonthly = 4,
    SowWeekly = 5,
    SowMonthly = 6,
}

export enum JobCategoryEnum {
    IT = 1,
    Clerical = 2,
    Executive = 3,
    Engineering = 4,
    AccountingOrFinance = 5,
    WarehousingOrLightIndustrial = 6,
    Healthcare = 7,
    Other = 8,
}

export enum KronosImportTypeEnum {
    I1CostCenter = 1,
    I2ApproversAgent = 2,
    I3Employee = 3,
    I4UnemploymentState = 4,
    Termination = 100,
    TerminationDetails = 101,
    MultiRates = 200,
}

export enum KronosInfoStatusEnum {
    AwaitingStatus = 0,
    Synced = 5,
    SyncedWithErrors = 10,
    SyncFailed = 15,
    ReprocessedManually = 20,
}

export interface LocationModel {
    address?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
}

export interface LocationViewModel {
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateId?: number | undefined;
    zipCode?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
}

export interface MemberCommentViewModel {
    id?: string;
    memberId?: string;
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    updatedById?: string | undefined;
    updatedByFirstName?: string | undefined;
    updatedByLastName?: string | undefined;
    text?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
}

export interface MemberCommentsPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: MemberCommentViewModel[] | undefined;
}

export interface MemberHistoryDetailsModel {
    oldData?: FullBOUserResponseModel;
    newData?: FullBOUserResponseModel;
}

export interface MemberLogoInfoEditModel {
    logoFileKey?: string | undefined;
}

export interface MemberLogoInfoViewModel {
    logoUrl?: string | undefined;
}

export enum MultiRateEnum {
    ProjectRate = 0,
    ShiftRa = 1,
    OnCall = 2,
    PaidTimeOff = 3,
    TaxableAmount = 4,
    NotTaxedAmount = 5,
}

export interface MultiRateSchedulerEditModel {
    payCodeId?: string;
    payRate?: number | undefined;
    billRate?: number | undefined;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
}

export interface MultiRateSchedulerViewModel {
    payRate?: number | undefined;
    billRate?: number | undefined;
    payCodeId?: string;
    hasPayRateCustomLogic?: boolean;
    hasBillRateCustomLogic?: boolean;
}

export interface NamedAttachmentModel {
    fileKey?: string | undefined;
    fileName?: string | undefined;
}

export enum OutreachEnum {
    Phone = 1,
    Email = 2,
}

export interface OutreachModel {
    outreachType?: OutreachEnum;
    phone?: string | undefined;
    email?: string | undefined;
    dates?: DateTimeModel[] | undefined;
}

export enum OvertimeEnum {
    Exempt = 1,
    Nonexempt = 2,
}

export interface PartnerGeneralInfoResponseModel {
    userId?: string;
    userKey?: string | undefined;
    companyName?: string | undefined;
    companyEIN?: string | undefined;
    subcontractorRate?: number | undefined;
    address?: string | undefined;
    cityId?: number | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: string | undefined;
    country?: string | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    zipCode?: string | undefined;
    assignmentsCount?: number | undefined;
    isRegisteredOnMarketplace?: boolean;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    userCompanyName?: string | undefined;
}

export interface PartnerPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: PartnerResponseModel[] | undefined;
}

export interface PartnerPrimaryContactModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface PartnerResponseModel {
    id?: string;
    primaryContact?: PartnerPrimaryContactModel;
    generalInfo?: PartnerGeneralInfoResponseModel;
    invitedCompanyId?: string | undefined;
    partnerStatus?: PartnerStatusEnum;
    creator?: CreatorUserModel;
}

export enum PartnerStatusEnum {
    None = 0,
    InvitationRequested = 1,
    Registered = 2,
    ProfileCompleted = 3,
    PendingPartnership = 4,
}

export interface PayCodeModel {
    id?: string;
    payRateTypeId?: string;
    name?: string | undefined;
    description?: string | undefined;
    orderNumber?: number;
    memberBilledIndicatorDefaultValue?: boolean | undefined;
}

export interface PayCodesGroup {
    jobCategory?: JobCategoryEnum;
    payCodes?: string[] | undefined;
}

export enum PayPeriodEnum {
    WeeklyMondaySunday = 1,
    BiWeeklyMondaySunday1 = 2,
    Monthly = 3,
    SemiMonthly = 4,
    WeeklyMondaySundayWedSubmit = 5,
    WeeklySaturdayFriday = 6,
    WeeklySundaySaturday = 7,
    BiWeeklyMondaySunday2 = 8,
    BiWeeklySundaySaturday1 = 9,
    BiWeeklySundaySaturday2 = 10,
    WeeklyThursdayWednesday = 11,
}

export interface PayRateTypeModel {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    additionalDescription?: string | undefined;
    orderNumber?: number;
}

export enum PayTypeEnum {
    Hourly = 1,
    Salary = 2,
}

export enum PaymentTermEnum {
    Net5 = 5,
    Net7 = 7,
    Net10 = 10,
    Net15 = 15,
    Net21 = 21,
    Net22 = 22,
    Net30 = 30,
    Net45 = 45,
    Net60 = 60,
    Net75 = 75,
    Net90 = 90,
    DueOnReceipt = -1,
}

export interface PersonInfoModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface PersonSelectModel {
    userId?: string;
    companyId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
}

export enum PreScreeningBilledToEnum {
    Member = 1,
    Customer = 2,
}

export interface PriceAgreementEEInfoModel {
    w2Price?: number;
    placementStateIds?: number[] | undefined;
    workCodes?: string[] | undefined;
}

export interface PriceAgreementHistoryDetailsBaseModel {
    w2InfoList?: PriceAgreementW2InfoResponseModel[] | undefined;
    icPrice?: number;
}

export interface PriceAgreementHistoryDetailsModel {
    oldPriceAgreement?: PriceAgreementHistoryDetailsBaseModel;
    newPriceAgreement?: PriceAgreementHistoryDetailsBaseModel;
}

export interface PriceAgreementW2InfoResponseModel {
    w2Price?: number;
    placementStates?: StateEntity[] | undefined;
    workCodes?: string[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ProfileCorporateBillingInfoModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ProfileCorporateInfoModel {
    companyId?: string;
    billingInfo?: ProfileCorporateBillingInfoModel;
    primaryContacts?: ProfileCorporatePrimaryContactInfoModel[] | undefined;
    supervisors?: ProfileCorporateSupervisorInfoModel[] | undefined;
    timesheetApprovers?: ProfileCorporateTimesheetApproverInfoModel[] | undefined;
}

export interface ProfileCorporatePrimaryContactInfoModel {
    contactId?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ProfileCorporatePrimaryContactsInfoModel {
    primarycontacts?: ProfileCorporatePrimaryContactInfoModel[] | undefined;
}

export interface ProfileCorporateSupervisorInfoModel {
    supervisorId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    title?: string | undefined;
}

export interface ProfileCorporateSupervisorsInfoModel {
    supervisors?: ProfileCorporateSupervisorInfoModel[] | undefined;
}

export interface ProfileCorporateTimesheetApproverInfoModel {
    timesheetApproverId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ProfileCorporateTimesheetApproversInfoModel {
    timesheetApprovers?: ProfileCorporateTimesheetApproverInfoModel[] | undefined;
}

export enum ProfileTypeEnum {
    Recruiter = 1,
    Corporate = 2,
}

export interface QuestionnaireModel {
    isValue?: boolean | undefined;
    comment?: string | undefined;
}

export enum RenewActionEnum {
    Submited = 0,
    Approved = 1,
}

export enum RenewAssignmentEnum {
    Default = 0,
    WithChanges = 1,
    WithoutChanges = 2,
    WithChangeCustomer = 3,
}

export interface RenewAssignmentModel {
    parentAssignmentId?: string;
    jobStartDate?: Date;
    jobEndDate?: Date;
    renewKind?: RenewKindEnum;
}

export interface RenewAssignmentWithChangesRequest {
    assignmentIsDraft?: boolean;
    assignmentType: AssignmentTypeEnum;
    assignmentCategory: AssignmentCategoryEnum;
    assignmentTeammates?: AssignmentTeammatesEditModel[] | undefined;
    assignmentInfo?: AssignmentInfoEditModel;
    financialInfo?: AssignmentFinancialInfoEditModel;
    bestPrimaryContacts?: AssignmentContactPersonEditModel[] | undefined;
    supervisorInfo?: AssignmentSupervisorInfoEditModel;
    timesheetApproverNotApplicable?: boolean;
    timesheetApproverSameAsSupervisor?: boolean;
    timesheetApproverInfo?: AssignmentTimesheetApproverInfoEditModel;
    additionalTimesheetApprovers?: AssignmentTimesheetApproverInfoEditModel[] | undefined;
    timesheetBackupApproverInfo?: AssignmentTimesheetBackupApproverInfoEditModel;
    workSameAsHomeOrBusinessLocation?: boolean;
    workLocation?: LocationModel;
    billingSameAsWorkLocation?: boolean;
    billingLocation?: LocationModel;
    billingEmail?: string | undefined;
    splitInfo?: AssignmentSplitInfoEditModel;
    partnerDraft?: AssignmentPartnerDraftModel;
    renewType?: RenewAssignmentEnum;
    renewKind?: RenewKindEnum;
    parentAssignmentId?: string | undefined;
    isNeedCreateTemplate?: boolean;
    templateName?: string | undefined;
    multiRates?: AssignmentMultiRateEditModel[] | undefined;
    financialScheduler?: AssignmentFinancialSchedulerEditModel;
}

export enum RenewKindEnum {
    None = 0,
    Renew = 1,
    Rehire = 2,
}

export enum RenewStatusEnum {
    Regular = 0,
    RenewRequest = 1,
    ParentRenewRequest = 2,
    Renewed = 3,
}

export interface ResourceDownloadResponse {
    /** File name to save */
    readonly fileName?: string | undefined;
    /** Url for get body of file from S3 via CloudFront */
    readonly downloadUrl: string;
    /** File key to save */
    readonly fileKey?: string | undefined;
}

export interface S3UploadResponse {
    /** S3Key for post model to BE */
    readonly s3Key: string;
    /** S3 required Header for upload */
    readonly contentType: string;
    /** Url for put body of file to S3 */
    readonly putUrl: string;
    /** Url for get body of file from S3 */
    readonly getUrl: string;
}

export interface SelectTeammateViewModel {
    teammateType?: AssignmentTeammateTypeEnum;
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: number | undefined;
    secretKey?: string;
    isLockedOut?: boolean;
}

export interface SelfEmployedRequestModel {
    companyId?: string;
    website?: string | undefined;
    ownerInfo?: PersonInfoModel;
    businessInfo?: BusinessInfoModel;
    bestContact?: PersonInfoModel;
}

export interface SendTimesheetStatusReportDetailRequestModel {
    email?: string | undefined;
    timesheetStatusReportDetailRequest?: TimesheetStatusReportDetailRequestModel;
}

export interface ServiceAgreementInfoModel {
    agreementDetailsType?: ServiceAgreementTypeEnum;
    agreementAttachments?: ExtendedNamedAttachmentModel[] | undefined;
    isAgreementNotAvailableConfirmed?: boolean | undefined;
}

export enum ServiceAgreementTypeEnum {
    MyBasePayAgreement = 1,
    ClientAgreement = 2,
    MemberAgreement = 3,
    NotAvailable = 4,
}

export enum Severity {
    Error = 0,
    Warning = 1,
    Info = 2,
}

export enum SplitTypeEnum {
    NoSplit = 0,
    ExistingPartner = 1,
    NewPartner = 2,
}

export enum StageStatusEnum {
    Pending = 1,
    SoftStop = 21,
    SoftStopHalfCompleted = 41,
    HardStop = 61,
    Completed = 81,
}

export interface StateEntity {
    id?: number;
    stateCode?: string | undefined;
    name?: string | undefined;
    countryId?: number;
}

export enum TimeAMPMEnum {
    AM = 1,
    PM = 2,
}

export enum TimePointEnum {
    T01H00M = 100,
    T02H00M = 200,
    T03H00M = 300,
    T04H00M = 400,
    T05H00M = 500,
    T06H00M = 600,
    T07H00M = 700,
    T08H00M = 800,
    T09H00M = 900,
    T10H00M = 1000,
    T11H00M = 1100,
    T12H00M = 1200,
}

export enum TimesheetStatusEnum {
    All = 0,
    Open = 1,
    Submitted = 2,
    Approved = 3,
}

export interface TimesheetStatusReportDetailModel {
    id?: number;
    assignmentKey?: string | undefined;
    customerKey?: string | undefined;
    customerName?: string | undefined;
    hours?: string | undefined;
    pto?: string | undefined;
    timesheetType?: string | undefined;
    assignmentType?: string | undefined;
    state?: string | undefined;
    timesheetStartDate?: Date;
    timesheetEndDate?: Date;
    approvedOn?: Date | undefined;
    approver?: string | undefined;
    workerKey?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
    memberKey?: string | undefined;
    companyName?: string | undefined;
}

export interface TimesheetStatusReportDetailRequestModel {
    pageNumber?: number;
    pageSize?: number;
    states?: TimesheetStatusEnum[] | undefined;
    customerIds?: string[] | undefined;
    workerIds?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    companyIds?: string[] | undefined;
}

export interface TimesheetStatusReportDetailResponseModel {
    pageNumber?: number;
    totalCount?: number;
    lastKronosSyncDate?: Date;
    details?: TimesheetStatusReportDetailModel[] | undefined;
}

export interface UpdateContractorCompanyModel {
    companyName?: string | undefined;
    representativeContact?: BaseEmployeeModel;
    location?: LocationModel;
}

export interface ValidationDetailsModel {
    errorMessage?: string | undefined;
    errorDetails?: any | undefined;
}

export interface ValidationFailure {
    propertyName?: string | undefined;
    errorMessage?: string | undefined;
    attemptedValue?: any | undefined;
    customState?: any | undefined;
    severity?: Severity;
    errorCode?: string | undefined;
    formattedMessagePlaceholderValues?: { [key: string]: any; } | undefined;
}

export interface WorkCodeModel {
    id?: string;
    workCode?: string | undefined;
}

export enum WorkFromHomeEnum {
    Unknown = 0,
    HomeOnly = 1,
    OnsiteOnly = 2,
    OnsitePotentialForTravel = 3,
    Hybrid = 4,
}

export interface WorkerDetailAdminViewModel {
    duplicates?: WorkerDetailViewModel[] | undefined;
    referredMembers?: WorkerRelatedMemberViewModel[] | undefined;
    referredAssignments?: WorkerRelatedAssignmentViewModel[] | undefined;
    readonly assignmentsCount?: number;
    id?: string;
    workerKey?: string | undefined;
    currentRevision?: number;
    workerType?: WorkerTypeEnum;
    workerInfo?: BaseEmployeeModel;
    isDuplicated?: boolean;
    createdDate?: Date;
    createdBy?: string;
    location?: LocationViewModel;
    creator?: CreatorUserModel;
}

export interface WorkerDetailViewModel {
    id?: string;
    workerKey?: string | undefined;
    currentRevision?: number;
    workerType?: WorkerTypeEnum;
    workerInfo?: BaseEmployeeModel;
    isDuplicated?: boolean;
    createdDate?: Date;
    createdBy?: string;
    location?: LocationViewModel;
    assignmentsCount?: number | undefined;
    creator?: CreatorUserModel;
}

export interface WorkerHistoryDetailsModel {
    oldData?: WorkerHistoryRequest;
    newData?: WorkerHistoryRequest;
}

export interface WorkerHistoryRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    taxId?: number | undefined;
    workerFileKey?: string | undefined;
    w9FileName?: string | undefined;
    location?: LocationModel;
    workerType?: WorkerTypeEnum;
}

export interface WorkerItemDetailViewModel {
    companyFirstName?: string | undefined;
    companyLastName?: string | undefined;
    memberKey?: string | undefined;
    id?: string;
    workerKey?: string | undefined;
    currentRevision?: number;
    workerType?: WorkerTypeEnum;
    workerInfo?: BaseEmployeeModel;
    isDuplicated?: boolean;
    createdDate?: Date;
    createdBy?: string;
    location?: LocationViewModel;
    assignmentsCount?: number | undefined;
    creator?: CreatorUserModel;
}

export interface WorkerItemDetailViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: WorkerItemDetailViewModel[] | undefined;
}

export interface WorkerRelatedAssignmentViewModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface WorkerRelatedMemberViewModel {
    id?: string;
    memberKey?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface WorkerSearchResponseModel {
    id?: string;
    workerKey?: string | undefined;
    workerFirstName?: string | undefined;
    workerLastName?: string | undefined;
}

export enum WorkerTypeEnum {
    EE = 1,
    IC = 2,
    SC = 3,
    InternationalIC = 4,
}

export enum YearsInBusinessEnum {
    DoNotKnow = 0,
    From0To1 = 1,
    From1To3 = 2,
    From3To5 = 3,
    From5Plus = 5,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}